/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { createFileRoute } from '@tanstack/react-router'

import { Route as rootRouteImport } from './routes/__root'
import { Route as SubscriptionRouteImport } from './routes/subscription'
import { Route as LockAccessRouteImport } from './routes/lock-access'
import { Route as AuthRouteImport } from './routes/auth'
import { Route as HubMetaNameRouteRouteImport } from './routes/$hubMetaName/route'
import { Route as IndexRouteImport } from './routes/index'
import { Route as SupportIndexRouteImport } from './routes/support/index'
import { Route as ProfileIndexRouteImport } from './routes/profile/index'
import { Route as OneDeliveryIndexRouteImport } from './routes/one-delivery/index'
import { Route as ClickncollectIndexRouteImport } from './routes/clickncollect/index'
import { Route as HubMetaNameIndexRouteImport } from './routes/$hubMetaName/index'
import { Route as ProfilePrivacyPolicyRouteImport } from './routes/profile/privacy-policy'
import { Route as ProfilePaymentRouteImport } from './routes/profile/payment'
import { Route as ProfileLocationsRouteImport } from './routes/profile/locations'
import { Route as ProfileImprintRouteImport } from './routes/profile/imprint'
import { Route as ProfileEditProfileRouteImport } from './routes/profile/edit-profile'
import { Route as ProfileChangeAppLanguageRouteImport } from './routes/profile/change-app-language'
import { Route as OneDeliverySettingsRouteImport } from './routes/one-delivery/settings'
import { Route as OneDeliveryPickupRouteImport } from './routes/one-delivery/pickup'
import { Route as OneDeliveryOpeningRouteImport } from './routes/one-delivery/opening'
import { Route as OneDeliveryNewShipmentRouteImport } from './routes/one-delivery/new-shipment'
import { Route as OneDeliveryFinishRouteImport } from './routes/one-delivery/finish'
import { Route as OneDeliveryCreditsRouteImport } from './routes/one-delivery/credits'
import { Route as OneDeliveryCollectRouteImport } from './routes/one-delivery/collect'
import { Route as ClickncollectOpeningRouteImport } from './routes/clickncollect/opening'
import { Route as ClickncollectFinishRouteImport } from './routes/clickncollect/finish'
import { Route as ClickncollectEmailRouteImport } from './routes/clickncollect/email'
import { Route as ClickncollectCollectRouteImport } from './routes/clickncollect/collect'
import { Route as SupportHowToUseIndexRouteImport } from './routes/support/how-to-use/index'
import { Route as OneDeliveryOnboardingIndexRouteImport } from './routes/one-delivery/onboarding/index'
import { Route as HubHubMetaNameIndexRouteImport } from './routes/hub.$hubMetaName.index'
import { Route as HubMetaNameWarenannahmeIndexRouteImport } from './routes/$hubMetaName/warenannahme/index'
import { Route as HubMetaNameSwapIndexRouteImport } from './routes/$hubMetaName/swap/index'
import { Route as HubMetaNameShopIndexRouteImport } from './routes/$hubMetaName/shop/index'
import { Route as HubMetaNameRaffleIndexRouteImport } from './routes/$hubMetaName/raffle/index'
import { Route as HubMetaNameLockIndexRouteImport } from './routes/$hubMetaName/lock/index'
import { Route as HubMetaNameLockB2cIndexRouteImport } from './routes/$hubMetaName/lock-b2c/index'
import { Route as HubMetaNameInstantBuyIndexRouteImport } from './routes/$hubMetaName/instant-buy/index'
import { Route as HubMetaNameConsultationIndexRouteImport } from './routes/$hubMetaName/consultation/index'
import { Route as SupportHowToUseShopAndCollectRouteImport } from './routes/support/how-to-use/shop-and-collect'
import { Route as SupportHowToUseOneDeliveryRouteImport } from './routes/support/how-to-use/one-delivery'
import { Route as SupportHowToUseInstantBuyRouteImport } from './routes/support/how-to-use/instant-buy'
import { Route as SupportHowToUseDonationsRouteImport } from './routes/support/how-to-use/donations'
import { Route as SupportHowToUseClickAndCollectRouteImport } from './routes/support/how-to-use/click-and-collect'
import { Route as OneDeliveryOnboardingSummaryRouteImport } from './routes/one-delivery/onboarding/summary'
import { Route as OneDeliveryOnboardingPricingRouteImport } from './routes/one-delivery/onboarding/pricing'
import { Route as OneDeliveryOnboardingFinishRouteImport } from './routes/one-delivery/onboarding/finish'
import { Route as OneDeliveryOnboardingComingSoonRouteImport } from './routes/one-delivery/onboarding/coming-soon'
import { Route as OneDeliveryBundleBundleIdRouteImport } from './routes/one-delivery/bundle.$bundleId'
import { Route as HubMetaNameWarenannahmePickupRouteImport } from './routes/$hubMetaName/warenannahme/pickup'
import { Route as HubMetaNameWarenannahmeActionRouteImport } from './routes/$hubMetaName/warenannahme/action'
import { Route as HubMetaNameWarenannahmeAccessRouteImport } from './routes/$hubMetaName/warenannahme/access'
import { Route as HubMetaNameSwapSuccessRouteImport } from './routes/$hubMetaName/swap/success'
import { Route as HubMetaNameSwapSelectRouteImport } from './routes/$hubMetaName/swap/select'
import { Route as HubMetaNameSwapMyRouteImport } from './routes/$hubMetaName/swap/my'
import { Route as HubMetaNameShopThankYouRouteImport } from './routes/$hubMetaName/shop/thank-you'
import { Route as HubMetaNameRaffleNoMorePlayingRouteImport } from './routes/$hubMetaName/raffle/no-more-playing'
import { Route as HubMetaNameRaffleAnotherOnePlayingRouteImport } from './routes/$hubMetaName/raffle/another-one-playing'
import { Route as HubMetaNamePickUpOpeningRouteImport } from './routes/$hubMetaName/pick-up/opening'
import { Route as HubMetaNamePickUpInstantBuyRouteImport } from './routes/$hubMetaName/pick-up/instant-buy'
import { Route as HubMetaNamePickUpFinishRouteImport } from './routes/$hubMetaName/pick-up/finish'
import { Route as HubMetaNamePickUpCollectRouteImport } from './routes/$hubMetaName/pick-up/collect'
import { Route as HubMetaNameLockSuccessRouteImport } from './routes/$hubMetaName/lock/success'
import { Route as HubMetaNameLockSelectRouteImport } from './routes/$hubMetaName/lock/select'
import { Route as HubMetaNameLockNewRouteImport } from './routes/$hubMetaName/lock/new'
import { Route as HubMetaNameLockMyRouteImport } from './routes/$hubMetaName/lock/my'
import { Route as HubMetaNameLockCouponsRouteImport } from './routes/$hubMetaName/lock/coupons'
import { Route as HubMetaNameLockCheckoutRouteImport } from './routes/$hubMetaName/lock/checkout'
import { Route as HubMetaNameLockB2cNewRouteImport } from './routes/$hubMetaName/lock-b2c/new'
import { Route as HubMetaNameLockB2cCheckoutRouteImport } from './routes/$hubMetaName/lock-b2c/checkout'
import { Route as HubMetaNameConsultationPhoneRouteImport } from './routes/$hubMetaName/consultation/phone'
import { Route as HubMetaNameConsultationContactRouteImport } from './routes/$hubMetaName/consultation/contact'
import { Route as HubMetaNameWarenannahmeDeliverIndexRouteImport } from './routes/$hubMetaName/warenannahme/deliver.index'
import { Route as HubMetaNameWarenannahmeDeliverSpaceIdRouteImport } from './routes/$hubMetaName/warenannahme/deliver.$spaceId'
import { Route as HubMetaNameSwapSummarySpaceIdRouteImport } from './routes/$hubMetaName/swap/summary.$spaceId'
import { Route as HubMetaNameSwapSharedAccessReservationIdRouteImport } from './routes/$hubMetaName/swap/shared-access.$reservationId'
import { Route as HubMetaNameSwapEndedReservationIdRouteImport } from './routes/$hubMetaName/swap/ended.$reservationId'
import { Route as HubMetaNameSwapEndRentalReservationIdRouteImport } from './routes/$hubMetaName/swap/end-rental.$reservationId'
import { Route as HubMetaNameRaffleRaffleIdThankYouRouteImport } from './routes/$hubMetaName/raffle/$raffleId/thank-you'
import { Route as HubMetaNameRaffleRaffleIdResultRouteImport } from './routes/$hubMetaName/raffle/$raffleId/result'
import { Route as HubMetaNameRaffleRaffleIdPlayRouteImport } from './routes/$hubMetaName/raffle/$raffleId/play'
import { Route as HubMetaNameLockSummarySpaceIdRouteImport } from './routes/$hubMetaName/lock/summary.$spaceId'
import { Route as HubMetaNameLockSharedAccessReservationIdRouteImport } from './routes/$hubMetaName/lock/shared-access.$reservationId'
import { Route as HubMetaNameLockPaySessionIdRouteImport } from './routes/$hubMetaName/lock/pay.$sessionId'
import { Route as HubMetaNameLockEndedReservationIdRouteImport } from './routes/$hubMetaName/lock/ended.$reservationId'
import { Route as HubMetaNameLockEndRentalReservationIdRouteImport } from './routes/$hubMetaName/lock/end-rental.$reservationId'

const HubMetaNameShopOrderSummaryLazyRouteImport = createFileRoute(
  '/$hubMetaName/shop/order-summary',
)()
const HubMetaNameInstantBuyOrderSummaryLazyRouteImport = createFileRoute(
  '/$hubMetaName/instant-buy/order-summary',
)()

const SubscriptionRoute = SubscriptionRouteImport.update({
  id: '/subscription',
  path: '/subscription',
  getParentRoute: () => rootRouteImport,
} as any)
const LockAccessRoute = LockAccessRouteImport.update({
  id: '/lock-access',
  path: '/lock-access',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthRoute = AuthRouteImport.update({
  id: '/auth',
  path: '/auth',
  getParentRoute: () => rootRouteImport,
} as any)
const HubMetaNameRouteRoute = HubMetaNameRouteRouteImport.update({
  id: '/$hubMetaName',
  path: '/$hubMetaName',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const SupportIndexRoute = SupportIndexRouteImport.update({
  id: '/support/',
  path: '/support/',
  getParentRoute: () => rootRouteImport,
} as any)
const ProfileIndexRoute = ProfileIndexRouteImport.update({
  id: '/profile/',
  path: '/profile/',
  getParentRoute: () => rootRouteImport,
} as any)
const OneDeliveryIndexRoute = OneDeliveryIndexRouteImport.update({
  id: '/one-delivery/',
  path: '/one-delivery/',
  getParentRoute: () => rootRouteImport,
} as any)
const ClickncollectIndexRoute = ClickncollectIndexRouteImport.update({
  id: '/clickncollect/',
  path: '/clickncollect/',
  getParentRoute: () => rootRouteImport,
} as any)
const HubMetaNameIndexRoute = HubMetaNameIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => HubMetaNameRouteRoute,
} as any)
const ProfilePrivacyPolicyRoute = ProfilePrivacyPolicyRouteImport.update({
  id: '/profile/privacy-policy',
  path: '/profile/privacy-policy',
  getParentRoute: () => rootRouteImport,
} as any)
const ProfilePaymentRoute = ProfilePaymentRouteImport.update({
  id: '/profile/payment',
  path: '/profile/payment',
  getParentRoute: () => rootRouteImport,
} as any)
const ProfileLocationsRoute = ProfileLocationsRouteImport.update({
  id: '/profile/locations',
  path: '/profile/locations',
  getParentRoute: () => rootRouteImport,
} as any)
const ProfileImprintRoute = ProfileImprintRouteImport.update({
  id: '/profile/imprint',
  path: '/profile/imprint',
  getParentRoute: () => rootRouteImport,
} as any)
const ProfileEditProfileRoute = ProfileEditProfileRouteImport.update({
  id: '/profile/edit-profile',
  path: '/profile/edit-profile',
  getParentRoute: () => rootRouteImport,
} as any)
const ProfileChangeAppLanguageRoute =
  ProfileChangeAppLanguageRouteImport.update({
    id: '/profile/change-app-language',
    path: '/profile/change-app-language',
    getParentRoute: () => rootRouteImport,
  } as any)
const OneDeliverySettingsRoute = OneDeliverySettingsRouteImport.update({
  id: '/one-delivery/settings',
  path: '/one-delivery/settings',
  getParentRoute: () => rootRouteImport,
} as any)
const OneDeliveryPickupRoute = OneDeliveryPickupRouteImport.update({
  id: '/one-delivery/pickup',
  path: '/one-delivery/pickup',
  getParentRoute: () => rootRouteImport,
} as any)
const OneDeliveryOpeningRoute = OneDeliveryOpeningRouteImport.update({
  id: '/one-delivery/opening',
  path: '/one-delivery/opening',
  getParentRoute: () => rootRouteImport,
} as any)
const OneDeliveryNewShipmentRoute = OneDeliveryNewShipmentRouteImport.update({
  id: '/one-delivery/new-shipment',
  path: '/one-delivery/new-shipment',
  getParentRoute: () => rootRouteImport,
} as any)
const OneDeliveryFinishRoute = OneDeliveryFinishRouteImport.update({
  id: '/one-delivery/finish',
  path: '/one-delivery/finish',
  getParentRoute: () => rootRouteImport,
} as any)
const OneDeliveryCreditsRoute = OneDeliveryCreditsRouteImport.update({
  id: '/one-delivery/credits',
  path: '/one-delivery/credits',
  getParentRoute: () => rootRouteImport,
} as any)
const OneDeliveryCollectRoute = OneDeliveryCollectRouteImport.update({
  id: '/one-delivery/collect',
  path: '/one-delivery/collect',
  getParentRoute: () => rootRouteImport,
} as any)
const ClickncollectOpeningRoute = ClickncollectOpeningRouteImport.update({
  id: '/clickncollect/opening',
  path: '/clickncollect/opening',
  getParentRoute: () => rootRouteImport,
} as any)
const ClickncollectFinishRoute = ClickncollectFinishRouteImport.update({
  id: '/clickncollect/finish',
  path: '/clickncollect/finish',
  getParentRoute: () => rootRouteImport,
} as any)
const ClickncollectEmailRoute = ClickncollectEmailRouteImport.update({
  id: '/clickncollect/email',
  path: '/clickncollect/email',
  getParentRoute: () => rootRouteImport,
} as any)
const ClickncollectCollectRoute = ClickncollectCollectRouteImport.update({
  id: '/clickncollect/collect',
  path: '/clickncollect/collect',
  getParentRoute: () => rootRouteImport,
} as any)
const SupportHowToUseIndexRoute = SupportHowToUseIndexRouteImport.update({
  id: '/support/how-to-use/',
  path: '/support/how-to-use/',
  getParentRoute: () => rootRouteImport,
} as any)
const OneDeliveryOnboardingIndexRoute =
  OneDeliveryOnboardingIndexRouteImport.update({
    id: '/one-delivery/onboarding/',
    path: '/one-delivery/onboarding/',
    getParentRoute: () => rootRouteImport,
  } as any)
const HubHubMetaNameIndexRoute = HubHubMetaNameIndexRouteImport.update({
  id: '/hub/$hubMetaName/',
  path: '/hub/$hubMetaName/',
  getParentRoute: () => rootRouteImport,
} as any)
const HubMetaNameWarenannahmeIndexRoute =
  HubMetaNameWarenannahmeIndexRouteImport.update({
    id: '/warenannahme/',
    path: '/warenannahme/',
    getParentRoute: () => HubMetaNameRouteRoute,
  } as any)
const HubMetaNameSwapIndexRoute = HubMetaNameSwapIndexRouteImport.update({
  id: '/swap/',
  path: '/swap/',
  getParentRoute: () => HubMetaNameRouteRoute,
} as any)
const HubMetaNameShopIndexRoute = HubMetaNameShopIndexRouteImport.update({
  id: '/shop/',
  path: '/shop/',
  getParentRoute: () => HubMetaNameRouteRoute,
} as any)
const HubMetaNameRaffleIndexRoute = HubMetaNameRaffleIndexRouteImport.update({
  id: '/raffle/',
  path: '/raffle/',
  getParentRoute: () => HubMetaNameRouteRoute,
} as any)
const HubMetaNameLockIndexRoute = HubMetaNameLockIndexRouteImport.update({
  id: '/lock/',
  path: '/lock/',
  getParentRoute: () => HubMetaNameRouteRoute,
} as any)
const HubMetaNameLockB2cIndexRoute = HubMetaNameLockB2cIndexRouteImport.update({
  id: '/lock-b2c/',
  path: '/lock-b2c/',
  getParentRoute: () => HubMetaNameRouteRoute,
} as any)
const HubMetaNameInstantBuyIndexRoute =
  HubMetaNameInstantBuyIndexRouteImport.update({
    id: '/instant-buy/',
    path: '/instant-buy/',
    getParentRoute: () => HubMetaNameRouteRoute,
  } as any)
const HubMetaNameConsultationIndexRoute =
  HubMetaNameConsultationIndexRouteImport.update({
    id: '/consultation/',
    path: '/consultation/',
    getParentRoute: () => HubMetaNameRouteRoute,
  } as any)
const HubMetaNameShopOrderSummaryLazyRoute =
  HubMetaNameShopOrderSummaryLazyRouteImport.update({
    id: '/shop/order-summary',
    path: '/shop/order-summary',
    getParentRoute: () => HubMetaNameRouteRoute,
  } as any).lazy(() =>
    import('./routes/$hubMetaName/shop/order-summary.lazy').then(
      (d) => d.Route,
    ),
  )
const HubMetaNameInstantBuyOrderSummaryLazyRoute =
  HubMetaNameInstantBuyOrderSummaryLazyRouteImport.update({
    id: '/instant-buy/order-summary',
    path: '/instant-buy/order-summary',
    getParentRoute: () => HubMetaNameRouteRoute,
  } as any).lazy(() =>
    import('./routes/$hubMetaName/instant-buy/order-summary.lazy').then(
      (d) => d.Route,
    ),
  )
const SupportHowToUseShopAndCollectRoute =
  SupportHowToUseShopAndCollectRouteImport.update({
    id: '/support/how-to-use/shop-and-collect',
    path: '/support/how-to-use/shop-and-collect',
    getParentRoute: () => rootRouteImport,
  } as any)
const SupportHowToUseOneDeliveryRoute =
  SupportHowToUseOneDeliveryRouteImport.update({
    id: '/support/how-to-use/one-delivery',
    path: '/support/how-to-use/one-delivery',
    getParentRoute: () => rootRouteImport,
  } as any)
const SupportHowToUseInstantBuyRoute =
  SupportHowToUseInstantBuyRouteImport.update({
    id: '/support/how-to-use/instant-buy',
    path: '/support/how-to-use/instant-buy',
    getParentRoute: () => rootRouteImport,
  } as any)
const SupportHowToUseDonationsRoute =
  SupportHowToUseDonationsRouteImport.update({
    id: '/support/how-to-use/donations',
    path: '/support/how-to-use/donations',
    getParentRoute: () => rootRouteImport,
  } as any)
const SupportHowToUseClickAndCollectRoute =
  SupportHowToUseClickAndCollectRouteImport.update({
    id: '/support/how-to-use/click-and-collect',
    path: '/support/how-to-use/click-and-collect',
    getParentRoute: () => rootRouteImport,
  } as any)
const OneDeliveryOnboardingSummaryRoute =
  OneDeliveryOnboardingSummaryRouteImport.update({
    id: '/one-delivery/onboarding/summary',
    path: '/one-delivery/onboarding/summary',
    getParentRoute: () => rootRouteImport,
  } as any)
const OneDeliveryOnboardingPricingRoute =
  OneDeliveryOnboardingPricingRouteImport.update({
    id: '/one-delivery/onboarding/pricing',
    path: '/one-delivery/onboarding/pricing',
    getParentRoute: () => rootRouteImport,
  } as any)
const OneDeliveryOnboardingFinishRoute =
  OneDeliveryOnboardingFinishRouteImport.update({
    id: '/one-delivery/onboarding/finish',
    path: '/one-delivery/onboarding/finish',
    getParentRoute: () => rootRouteImport,
  } as any)
const OneDeliveryOnboardingComingSoonRoute =
  OneDeliveryOnboardingComingSoonRouteImport.update({
    id: '/one-delivery/onboarding/coming-soon',
    path: '/one-delivery/onboarding/coming-soon',
    getParentRoute: () => rootRouteImport,
  } as any)
const OneDeliveryBundleBundleIdRoute =
  OneDeliveryBundleBundleIdRouteImport.update({
    id: '/one-delivery/bundle/$bundleId',
    path: '/one-delivery/bundle/$bundleId',
    getParentRoute: () => rootRouteImport,
  } as any)
const HubMetaNameWarenannahmePickupRoute =
  HubMetaNameWarenannahmePickupRouteImport.update({
    id: '/warenannahme/pickup',
    path: '/warenannahme/pickup',
    getParentRoute: () => HubMetaNameRouteRoute,
  } as any)
const HubMetaNameWarenannahmeActionRoute =
  HubMetaNameWarenannahmeActionRouteImport.update({
    id: '/warenannahme/action',
    path: '/warenannahme/action',
    getParentRoute: () => HubMetaNameRouteRoute,
  } as any)
const HubMetaNameWarenannahmeAccessRoute =
  HubMetaNameWarenannahmeAccessRouteImport.update({
    id: '/warenannahme/access',
    path: '/warenannahme/access',
    getParentRoute: () => HubMetaNameRouteRoute,
  } as any)
const HubMetaNameSwapSuccessRoute = HubMetaNameSwapSuccessRouteImport.update({
  id: '/swap/success',
  path: '/swap/success',
  getParentRoute: () => HubMetaNameRouteRoute,
} as any)
const HubMetaNameSwapSelectRoute = HubMetaNameSwapSelectRouteImport.update({
  id: '/swap/select',
  path: '/swap/select',
  getParentRoute: () => HubMetaNameRouteRoute,
} as any)
const HubMetaNameSwapMyRoute = HubMetaNameSwapMyRouteImport.update({
  id: '/swap/my',
  path: '/swap/my',
  getParentRoute: () => HubMetaNameRouteRoute,
} as any)
const HubMetaNameShopThankYouRoute = HubMetaNameShopThankYouRouteImport.update({
  id: '/shop/thank-you',
  path: '/shop/thank-you',
  getParentRoute: () => HubMetaNameRouteRoute,
} as any)
const HubMetaNameRaffleNoMorePlayingRoute =
  HubMetaNameRaffleNoMorePlayingRouteImport.update({
    id: '/raffle/no-more-playing',
    path: '/raffle/no-more-playing',
    getParentRoute: () => HubMetaNameRouteRoute,
  } as any)
const HubMetaNameRaffleAnotherOnePlayingRoute =
  HubMetaNameRaffleAnotherOnePlayingRouteImport.update({
    id: '/raffle/another-one-playing',
    path: '/raffle/another-one-playing',
    getParentRoute: () => HubMetaNameRouteRoute,
  } as any)
const HubMetaNamePickUpOpeningRoute =
  HubMetaNamePickUpOpeningRouteImport.update({
    id: '/pick-up/opening',
    path: '/pick-up/opening',
    getParentRoute: () => HubMetaNameRouteRoute,
  } as any)
const HubMetaNamePickUpInstantBuyRoute =
  HubMetaNamePickUpInstantBuyRouteImport.update({
    id: '/pick-up/instant-buy',
    path: '/pick-up/instant-buy',
    getParentRoute: () => HubMetaNameRouteRoute,
  } as any)
const HubMetaNamePickUpFinishRoute = HubMetaNamePickUpFinishRouteImport.update({
  id: '/pick-up/finish',
  path: '/pick-up/finish',
  getParentRoute: () => HubMetaNameRouteRoute,
} as any)
const HubMetaNamePickUpCollectRoute =
  HubMetaNamePickUpCollectRouteImport.update({
    id: '/pick-up/collect',
    path: '/pick-up/collect',
    getParentRoute: () => HubMetaNameRouteRoute,
  } as any)
const HubMetaNameLockSuccessRoute = HubMetaNameLockSuccessRouteImport.update({
  id: '/lock/success',
  path: '/lock/success',
  getParentRoute: () => HubMetaNameRouteRoute,
} as any)
const HubMetaNameLockSelectRoute = HubMetaNameLockSelectRouteImport.update({
  id: '/lock/select',
  path: '/lock/select',
  getParentRoute: () => HubMetaNameRouteRoute,
} as any)
const HubMetaNameLockNewRoute = HubMetaNameLockNewRouteImport.update({
  id: '/lock/new',
  path: '/lock/new',
  getParentRoute: () => HubMetaNameRouteRoute,
} as any)
const HubMetaNameLockMyRoute = HubMetaNameLockMyRouteImport.update({
  id: '/lock/my',
  path: '/lock/my',
  getParentRoute: () => HubMetaNameRouteRoute,
} as any)
const HubMetaNameLockCouponsRoute = HubMetaNameLockCouponsRouteImport.update({
  id: '/lock/coupons',
  path: '/lock/coupons',
  getParentRoute: () => HubMetaNameRouteRoute,
} as any)
const HubMetaNameLockCheckoutRoute = HubMetaNameLockCheckoutRouteImport.update({
  id: '/lock/checkout',
  path: '/lock/checkout',
  getParentRoute: () => HubMetaNameRouteRoute,
} as any)
const HubMetaNameLockB2cNewRoute = HubMetaNameLockB2cNewRouteImport.update({
  id: '/lock-b2c/new',
  path: '/lock-b2c/new',
  getParentRoute: () => HubMetaNameRouteRoute,
} as any)
const HubMetaNameLockB2cCheckoutRoute =
  HubMetaNameLockB2cCheckoutRouteImport.update({
    id: '/lock-b2c/checkout',
    path: '/lock-b2c/checkout',
    getParentRoute: () => HubMetaNameRouteRoute,
  } as any)
const HubMetaNameConsultationPhoneRoute =
  HubMetaNameConsultationPhoneRouteImport.update({
    id: '/consultation/phone',
    path: '/consultation/phone',
    getParentRoute: () => HubMetaNameRouteRoute,
  } as any)
const HubMetaNameConsultationContactRoute =
  HubMetaNameConsultationContactRouteImport.update({
    id: '/consultation/contact',
    path: '/consultation/contact',
    getParentRoute: () => HubMetaNameRouteRoute,
  } as any)
const HubMetaNameWarenannahmeDeliverIndexRoute =
  HubMetaNameWarenannahmeDeliverIndexRouteImport.update({
    id: '/warenannahme/deliver/',
    path: '/warenannahme/deliver/',
    getParentRoute: () => HubMetaNameRouteRoute,
  } as any)
const HubMetaNameWarenannahmeDeliverSpaceIdRoute =
  HubMetaNameWarenannahmeDeliverSpaceIdRouteImport.update({
    id: '/warenannahme/deliver/$spaceId',
    path: '/warenannahme/deliver/$spaceId',
    getParentRoute: () => HubMetaNameRouteRoute,
  } as any)
const HubMetaNameSwapSummarySpaceIdRoute =
  HubMetaNameSwapSummarySpaceIdRouteImport.update({
    id: '/swap/summary/$spaceId',
    path: '/swap/summary/$spaceId',
    getParentRoute: () => HubMetaNameRouteRoute,
  } as any)
const HubMetaNameSwapSharedAccessReservationIdRoute =
  HubMetaNameSwapSharedAccessReservationIdRouteImport.update({
    id: '/swap/shared-access/$reservationId',
    path: '/swap/shared-access/$reservationId',
    getParentRoute: () => HubMetaNameRouteRoute,
  } as any)
const HubMetaNameSwapEndedReservationIdRoute =
  HubMetaNameSwapEndedReservationIdRouteImport.update({
    id: '/swap/ended/$reservationId',
    path: '/swap/ended/$reservationId',
    getParentRoute: () => HubMetaNameRouteRoute,
  } as any)
const HubMetaNameSwapEndRentalReservationIdRoute =
  HubMetaNameSwapEndRentalReservationIdRouteImport.update({
    id: '/swap/end-rental/$reservationId',
    path: '/swap/end-rental/$reservationId',
    getParentRoute: () => HubMetaNameRouteRoute,
  } as any)
const HubMetaNameRaffleRaffleIdThankYouRoute =
  HubMetaNameRaffleRaffleIdThankYouRouteImport.update({
    id: '/raffle/$raffleId/thank-you',
    path: '/raffle/$raffleId/thank-you',
    getParentRoute: () => HubMetaNameRouteRoute,
  } as any)
const HubMetaNameRaffleRaffleIdResultRoute =
  HubMetaNameRaffleRaffleIdResultRouteImport.update({
    id: '/raffle/$raffleId/result',
    path: '/raffle/$raffleId/result',
    getParentRoute: () => HubMetaNameRouteRoute,
  } as any)
const HubMetaNameRaffleRaffleIdPlayRoute =
  HubMetaNameRaffleRaffleIdPlayRouteImport.update({
    id: '/raffle/$raffleId/play',
    path: '/raffle/$raffleId/play',
    getParentRoute: () => HubMetaNameRouteRoute,
  } as any)
const HubMetaNameLockSummarySpaceIdRoute =
  HubMetaNameLockSummarySpaceIdRouteImport.update({
    id: '/lock/summary/$spaceId',
    path: '/lock/summary/$spaceId',
    getParentRoute: () => HubMetaNameRouteRoute,
  } as any)
const HubMetaNameLockSharedAccessReservationIdRoute =
  HubMetaNameLockSharedAccessReservationIdRouteImport.update({
    id: '/lock/shared-access/$reservationId',
    path: '/lock/shared-access/$reservationId',
    getParentRoute: () => HubMetaNameRouteRoute,
  } as any)
const HubMetaNameLockPaySessionIdRoute =
  HubMetaNameLockPaySessionIdRouteImport.update({
    id: '/lock/pay/$sessionId',
    path: '/lock/pay/$sessionId',
    getParentRoute: () => HubMetaNameRouteRoute,
  } as any)
const HubMetaNameLockEndedReservationIdRoute =
  HubMetaNameLockEndedReservationIdRouteImport.update({
    id: '/lock/ended/$reservationId',
    path: '/lock/ended/$reservationId',
    getParentRoute: () => HubMetaNameRouteRoute,
  } as any)
const HubMetaNameLockEndRentalReservationIdRoute =
  HubMetaNameLockEndRentalReservationIdRouteImport.update({
    id: '/lock/end-rental/$reservationId',
    path: '/lock/end-rental/$reservationId',
    getParentRoute: () => HubMetaNameRouteRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/$hubMetaName': typeof HubMetaNameRouteRouteWithChildren
  '/auth': typeof AuthRoute
  '/lock-access': typeof LockAccessRoute
  '/subscription': typeof SubscriptionRoute
  '/clickncollect/collect': typeof ClickncollectCollectRoute
  '/clickncollect/email': typeof ClickncollectEmailRoute
  '/clickncollect/finish': typeof ClickncollectFinishRoute
  '/clickncollect/opening': typeof ClickncollectOpeningRoute
  '/one-delivery/collect': typeof OneDeliveryCollectRoute
  '/one-delivery/credits': typeof OneDeliveryCreditsRoute
  '/one-delivery/finish': typeof OneDeliveryFinishRoute
  '/one-delivery/new-shipment': typeof OneDeliveryNewShipmentRoute
  '/one-delivery/opening': typeof OneDeliveryOpeningRoute
  '/one-delivery/pickup': typeof OneDeliveryPickupRoute
  '/one-delivery/settings': typeof OneDeliverySettingsRoute
  '/profile/change-app-language': typeof ProfileChangeAppLanguageRoute
  '/profile/edit-profile': typeof ProfileEditProfileRoute
  '/profile/imprint': typeof ProfileImprintRoute
  '/profile/locations': typeof ProfileLocationsRoute
  '/profile/payment': typeof ProfilePaymentRoute
  '/profile/privacy-policy': typeof ProfilePrivacyPolicyRoute
  '/$hubMetaName/': typeof HubMetaNameIndexRoute
  '/clickncollect/': typeof ClickncollectIndexRoute
  '/one-delivery/': typeof OneDeliveryIndexRoute
  '/profile/': typeof ProfileIndexRoute
  '/support/': typeof SupportIndexRoute
  '/$hubMetaName/consultation/contact': typeof HubMetaNameConsultationContactRoute
  '/$hubMetaName/consultation/phone': typeof HubMetaNameConsultationPhoneRoute
  '/$hubMetaName/lock-b2c/checkout': typeof HubMetaNameLockB2cCheckoutRoute
  '/$hubMetaName/lock-b2c/new': typeof HubMetaNameLockB2cNewRoute
  '/$hubMetaName/lock/checkout': typeof HubMetaNameLockCheckoutRoute
  '/$hubMetaName/lock/coupons': typeof HubMetaNameLockCouponsRoute
  '/$hubMetaName/lock/my': typeof HubMetaNameLockMyRoute
  '/$hubMetaName/lock/new': typeof HubMetaNameLockNewRoute
  '/$hubMetaName/lock/select': typeof HubMetaNameLockSelectRoute
  '/$hubMetaName/lock/success': typeof HubMetaNameLockSuccessRoute
  '/$hubMetaName/pick-up/collect': typeof HubMetaNamePickUpCollectRoute
  '/$hubMetaName/pick-up/finish': typeof HubMetaNamePickUpFinishRoute
  '/$hubMetaName/pick-up/instant-buy': typeof HubMetaNamePickUpInstantBuyRoute
  '/$hubMetaName/pick-up/opening': typeof HubMetaNamePickUpOpeningRoute
  '/$hubMetaName/raffle/another-one-playing': typeof HubMetaNameRaffleAnotherOnePlayingRoute
  '/$hubMetaName/raffle/no-more-playing': typeof HubMetaNameRaffleNoMorePlayingRoute
  '/$hubMetaName/shop/thank-you': typeof HubMetaNameShopThankYouRoute
  '/$hubMetaName/swap/my': typeof HubMetaNameSwapMyRoute
  '/$hubMetaName/swap/select': typeof HubMetaNameSwapSelectRoute
  '/$hubMetaName/swap/success': typeof HubMetaNameSwapSuccessRoute
  '/$hubMetaName/warenannahme/access': typeof HubMetaNameWarenannahmeAccessRoute
  '/$hubMetaName/warenannahme/action': typeof HubMetaNameWarenannahmeActionRoute
  '/$hubMetaName/warenannahme/pickup': typeof HubMetaNameWarenannahmePickupRoute
  '/one-delivery/bundle/$bundleId': typeof OneDeliveryBundleBundleIdRoute
  '/one-delivery/onboarding/coming-soon': typeof OneDeliveryOnboardingComingSoonRoute
  '/one-delivery/onboarding/finish': typeof OneDeliveryOnboardingFinishRoute
  '/one-delivery/onboarding/pricing': typeof OneDeliveryOnboardingPricingRoute
  '/one-delivery/onboarding/summary': typeof OneDeliveryOnboardingSummaryRoute
  '/support/how-to-use/click-and-collect': typeof SupportHowToUseClickAndCollectRoute
  '/support/how-to-use/donations': typeof SupportHowToUseDonationsRoute
  '/support/how-to-use/instant-buy': typeof SupportHowToUseInstantBuyRoute
  '/support/how-to-use/one-delivery': typeof SupportHowToUseOneDeliveryRoute
  '/support/how-to-use/shop-and-collect': typeof SupportHowToUseShopAndCollectRoute
  '/$hubMetaName/instant-buy/order-summary': typeof HubMetaNameInstantBuyOrderSummaryLazyRoute
  '/$hubMetaName/shop/order-summary': typeof HubMetaNameShopOrderSummaryLazyRoute
  '/$hubMetaName/consultation/': typeof HubMetaNameConsultationIndexRoute
  '/$hubMetaName/instant-buy/': typeof HubMetaNameInstantBuyIndexRoute
  '/$hubMetaName/lock-b2c/': typeof HubMetaNameLockB2cIndexRoute
  '/$hubMetaName/lock/': typeof HubMetaNameLockIndexRoute
  '/$hubMetaName/raffle/': typeof HubMetaNameRaffleIndexRoute
  '/$hubMetaName/shop/': typeof HubMetaNameShopIndexRoute
  '/$hubMetaName/swap/': typeof HubMetaNameSwapIndexRoute
  '/$hubMetaName/warenannahme/': typeof HubMetaNameWarenannahmeIndexRoute
  '/hub/$hubMetaName/': typeof HubHubMetaNameIndexRoute
  '/one-delivery/onboarding/': typeof OneDeliveryOnboardingIndexRoute
  '/support/how-to-use/': typeof SupportHowToUseIndexRoute
  '/$hubMetaName/lock/end-rental/$reservationId': typeof HubMetaNameLockEndRentalReservationIdRoute
  '/$hubMetaName/lock/ended/$reservationId': typeof HubMetaNameLockEndedReservationIdRoute
  '/$hubMetaName/lock/pay/$sessionId': typeof HubMetaNameLockPaySessionIdRoute
  '/$hubMetaName/lock/shared-access/$reservationId': typeof HubMetaNameLockSharedAccessReservationIdRoute
  '/$hubMetaName/lock/summary/$spaceId': typeof HubMetaNameLockSummarySpaceIdRoute
  '/$hubMetaName/raffle/$raffleId/play': typeof HubMetaNameRaffleRaffleIdPlayRoute
  '/$hubMetaName/raffle/$raffleId/result': typeof HubMetaNameRaffleRaffleIdResultRoute
  '/$hubMetaName/raffle/$raffleId/thank-you': typeof HubMetaNameRaffleRaffleIdThankYouRoute
  '/$hubMetaName/swap/end-rental/$reservationId': typeof HubMetaNameSwapEndRentalReservationIdRoute
  '/$hubMetaName/swap/ended/$reservationId': typeof HubMetaNameSwapEndedReservationIdRoute
  '/$hubMetaName/swap/shared-access/$reservationId': typeof HubMetaNameSwapSharedAccessReservationIdRoute
  '/$hubMetaName/swap/summary/$spaceId': typeof HubMetaNameSwapSummarySpaceIdRoute
  '/$hubMetaName/warenannahme/deliver/$spaceId': typeof HubMetaNameWarenannahmeDeliverSpaceIdRoute
  '/$hubMetaName/warenannahme/deliver/': typeof HubMetaNameWarenannahmeDeliverIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/auth': typeof AuthRoute
  '/lock-access': typeof LockAccessRoute
  '/subscription': typeof SubscriptionRoute
  '/clickncollect/collect': typeof ClickncollectCollectRoute
  '/clickncollect/email': typeof ClickncollectEmailRoute
  '/clickncollect/finish': typeof ClickncollectFinishRoute
  '/clickncollect/opening': typeof ClickncollectOpeningRoute
  '/one-delivery/collect': typeof OneDeliveryCollectRoute
  '/one-delivery/credits': typeof OneDeliveryCreditsRoute
  '/one-delivery/finish': typeof OneDeliveryFinishRoute
  '/one-delivery/new-shipment': typeof OneDeliveryNewShipmentRoute
  '/one-delivery/opening': typeof OneDeliveryOpeningRoute
  '/one-delivery/pickup': typeof OneDeliveryPickupRoute
  '/one-delivery/settings': typeof OneDeliverySettingsRoute
  '/profile/change-app-language': typeof ProfileChangeAppLanguageRoute
  '/profile/edit-profile': typeof ProfileEditProfileRoute
  '/profile/imprint': typeof ProfileImprintRoute
  '/profile/locations': typeof ProfileLocationsRoute
  '/profile/payment': typeof ProfilePaymentRoute
  '/profile/privacy-policy': typeof ProfilePrivacyPolicyRoute
  '/$hubMetaName': typeof HubMetaNameIndexRoute
  '/clickncollect': typeof ClickncollectIndexRoute
  '/one-delivery': typeof OneDeliveryIndexRoute
  '/profile': typeof ProfileIndexRoute
  '/support': typeof SupportIndexRoute
  '/$hubMetaName/consultation/contact': typeof HubMetaNameConsultationContactRoute
  '/$hubMetaName/consultation/phone': typeof HubMetaNameConsultationPhoneRoute
  '/$hubMetaName/lock-b2c/checkout': typeof HubMetaNameLockB2cCheckoutRoute
  '/$hubMetaName/lock-b2c/new': typeof HubMetaNameLockB2cNewRoute
  '/$hubMetaName/lock/checkout': typeof HubMetaNameLockCheckoutRoute
  '/$hubMetaName/lock/coupons': typeof HubMetaNameLockCouponsRoute
  '/$hubMetaName/lock/my': typeof HubMetaNameLockMyRoute
  '/$hubMetaName/lock/new': typeof HubMetaNameLockNewRoute
  '/$hubMetaName/lock/select': typeof HubMetaNameLockSelectRoute
  '/$hubMetaName/lock/success': typeof HubMetaNameLockSuccessRoute
  '/$hubMetaName/pick-up/collect': typeof HubMetaNamePickUpCollectRoute
  '/$hubMetaName/pick-up/finish': typeof HubMetaNamePickUpFinishRoute
  '/$hubMetaName/pick-up/instant-buy': typeof HubMetaNamePickUpInstantBuyRoute
  '/$hubMetaName/pick-up/opening': typeof HubMetaNamePickUpOpeningRoute
  '/$hubMetaName/raffle/another-one-playing': typeof HubMetaNameRaffleAnotherOnePlayingRoute
  '/$hubMetaName/raffle/no-more-playing': typeof HubMetaNameRaffleNoMorePlayingRoute
  '/$hubMetaName/shop/thank-you': typeof HubMetaNameShopThankYouRoute
  '/$hubMetaName/swap/my': typeof HubMetaNameSwapMyRoute
  '/$hubMetaName/swap/select': typeof HubMetaNameSwapSelectRoute
  '/$hubMetaName/swap/success': typeof HubMetaNameSwapSuccessRoute
  '/$hubMetaName/warenannahme/access': typeof HubMetaNameWarenannahmeAccessRoute
  '/$hubMetaName/warenannahme/action': typeof HubMetaNameWarenannahmeActionRoute
  '/$hubMetaName/warenannahme/pickup': typeof HubMetaNameWarenannahmePickupRoute
  '/one-delivery/bundle/$bundleId': typeof OneDeliveryBundleBundleIdRoute
  '/one-delivery/onboarding/coming-soon': typeof OneDeliveryOnboardingComingSoonRoute
  '/one-delivery/onboarding/finish': typeof OneDeliveryOnboardingFinishRoute
  '/one-delivery/onboarding/pricing': typeof OneDeliveryOnboardingPricingRoute
  '/one-delivery/onboarding/summary': typeof OneDeliveryOnboardingSummaryRoute
  '/support/how-to-use/click-and-collect': typeof SupportHowToUseClickAndCollectRoute
  '/support/how-to-use/donations': typeof SupportHowToUseDonationsRoute
  '/support/how-to-use/instant-buy': typeof SupportHowToUseInstantBuyRoute
  '/support/how-to-use/one-delivery': typeof SupportHowToUseOneDeliveryRoute
  '/support/how-to-use/shop-and-collect': typeof SupportHowToUseShopAndCollectRoute
  '/$hubMetaName/instant-buy/order-summary': typeof HubMetaNameInstantBuyOrderSummaryLazyRoute
  '/$hubMetaName/shop/order-summary': typeof HubMetaNameShopOrderSummaryLazyRoute
  '/$hubMetaName/consultation': typeof HubMetaNameConsultationIndexRoute
  '/$hubMetaName/instant-buy': typeof HubMetaNameInstantBuyIndexRoute
  '/$hubMetaName/lock-b2c': typeof HubMetaNameLockB2cIndexRoute
  '/$hubMetaName/lock': typeof HubMetaNameLockIndexRoute
  '/$hubMetaName/raffle': typeof HubMetaNameRaffleIndexRoute
  '/$hubMetaName/shop': typeof HubMetaNameShopIndexRoute
  '/$hubMetaName/swap': typeof HubMetaNameSwapIndexRoute
  '/$hubMetaName/warenannahme': typeof HubMetaNameWarenannahmeIndexRoute
  '/hub/$hubMetaName': typeof HubHubMetaNameIndexRoute
  '/one-delivery/onboarding': typeof OneDeliveryOnboardingIndexRoute
  '/support/how-to-use': typeof SupportHowToUseIndexRoute
  '/$hubMetaName/lock/end-rental/$reservationId': typeof HubMetaNameLockEndRentalReservationIdRoute
  '/$hubMetaName/lock/ended/$reservationId': typeof HubMetaNameLockEndedReservationIdRoute
  '/$hubMetaName/lock/pay/$sessionId': typeof HubMetaNameLockPaySessionIdRoute
  '/$hubMetaName/lock/shared-access/$reservationId': typeof HubMetaNameLockSharedAccessReservationIdRoute
  '/$hubMetaName/lock/summary/$spaceId': typeof HubMetaNameLockSummarySpaceIdRoute
  '/$hubMetaName/raffle/$raffleId/play': typeof HubMetaNameRaffleRaffleIdPlayRoute
  '/$hubMetaName/raffle/$raffleId/result': typeof HubMetaNameRaffleRaffleIdResultRoute
  '/$hubMetaName/raffle/$raffleId/thank-you': typeof HubMetaNameRaffleRaffleIdThankYouRoute
  '/$hubMetaName/swap/end-rental/$reservationId': typeof HubMetaNameSwapEndRentalReservationIdRoute
  '/$hubMetaName/swap/ended/$reservationId': typeof HubMetaNameSwapEndedReservationIdRoute
  '/$hubMetaName/swap/shared-access/$reservationId': typeof HubMetaNameSwapSharedAccessReservationIdRoute
  '/$hubMetaName/swap/summary/$spaceId': typeof HubMetaNameSwapSummarySpaceIdRoute
  '/$hubMetaName/warenannahme/deliver/$spaceId': typeof HubMetaNameWarenannahmeDeliverSpaceIdRoute
  '/$hubMetaName/warenannahme/deliver': typeof HubMetaNameWarenannahmeDeliverIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/$hubMetaName': typeof HubMetaNameRouteRouteWithChildren
  '/auth': typeof AuthRoute
  '/lock-access': typeof LockAccessRoute
  '/subscription': typeof SubscriptionRoute
  '/clickncollect/collect': typeof ClickncollectCollectRoute
  '/clickncollect/email': typeof ClickncollectEmailRoute
  '/clickncollect/finish': typeof ClickncollectFinishRoute
  '/clickncollect/opening': typeof ClickncollectOpeningRoute
  '/one-delivery/collect': typeof OneDeliveryCollectRoute
  '/one-delivery/credits': typeof OneDeliveryCreditsRoute
  '/one-delivery/finish': typeof OneDeliveryFinishRoute
  '/one-delivery/new-shipment': typeof OneDeliveryNewShipmentRoute
  '/one-delivery/opening': typeof OneDeliveryOpeningRoute
  '/one-delivery/pickup': typeof OneDeliveryPickupRoute
  '/one-delivery/settings': typeof OneDeliverySettingsRoute
  '/profile/change-app-language': typeof ProfileChangeAppLanguageRoute
  '/profile/edit-profile': typeof ProfileEditProfileRoute
  '/profile/imprint': typeof ProfileImprintRoute
  '/profile/locations': typeof ProfileLocationsRoute
  '/profile/payment': typeof ProfilePaymentRoute
  '/profile/privacy-policy': typeof ProfilePrivacyPolicyRoute
  '/$hubMetaName/': typeof HubMetaNameIndexRoute
  '/clickncollect/': typeof ClickncollectIndexRoute
  '/one-delivery/': typeof OneDeliveryIndexRoute
  '/profile/': typeof ProfileIndexRoute
  '/support/': typeof SupportIndexRoute
  '/$hubMetaName/consultation/contact': typeof HubMetaNameConsultationContactRoute
  '/$hubMetaName/consultation/phone': typeof HubMetaNameConsultationPhoneRoute
  '/$hubMetaName/lock-b2c/checkout': typeof HubMetaNameLockB2cCheckoutRoute
  '/$hubMetaName/lock-b2c/new': typeof HubMetaNameLockB2cNewRoute
  '/$hubMetaName/lock/checkout': typeof HubMetaNameLockCheckoutRoute
  '/$hubMetaName/lock/coupons': typeof HubMetaNameLockCouponsRoute
  '/$hubMetaName/lock/my': typeof HubMetaNameLockMyRoute
  '/$hubMetaName/lock/new': typeof HubMetaNameLockNewRoute
  '/$hubMetaName/lock/select': typeof HubMetaNameLockSelectRoute
  '/$hubMetaName/lock/success': typeof HubMetaNameLockSuccessRoute
  '/$hubMetaName/pick-up/collect': typeof HubMetaNamePickUpCollectRoute
  '/$hubMetaName/pick-up/finish': typeof HubMetaNamePickUpFinishRoute
  '/$hubMetaName/pick-up/instant-buy': typeof HubMetaNamePickUpInstantBuyRoute
  '/$hubMetaName/pick-up/opening': typeof HubMetaNamePickUpOpeningRoute
  '/$hubMetaName/raffle/another-one-playing': typeof HubMetaNameRaffleAnotherOnePlayingRoute
  '/$hubMetaName/raffle/no-more-playing': typeof HubMetaNameRaffleNoMorePlayingRoute
  '/$hubMetaName/shop/thank-you': typeof HubMetaNameShopThankYouRoute
  '/$hubMetaName/swap/my': typeof HubMetaNameSwapMyRoute
  '/$hubMetaName/swap/select': typeof HubMetaNameSwapSelectRoute
  '/$hubMetaName/swap/success': typeof HubMetaNameSwapSuccessRoute
  '/$hubMetaName/warenannahme/access': typeof HubMetaNameWarenannahmeAccessRoute
  '/$hubMetaName/warenannahme/action': typeof HubMetaNameWarenannahmeActionRoute
  '/$hubMetaName/warenannahme/pickup': typeof HubMetaNameWarenannahmePickupRoute
  '/one-delivery/bundle/$bundleId': typeof OneDeliveryBundleBundleIdRoute
  '/one-delivery/onboarding/coming-soon': typeof OneDeliveryOnboardingComingSoonRoute
  '/one-delivery/onboarding/finish': typeof OneDeliveryOnboardingFinishRoute
  '/one-delivery/onboarding/pricing': typeof OneDeliveryOnboardingPricingRoute
  '/one-delivery/onboarding/summary': typeof OneDeliveryOnboardingSummaryRoute
  '/support/how-to-use/click-and-collect': typeof SupportHowToUseClickAndCollectRoute
  '/support/how-to-use/donations': typeof SupportHowToUseDonationsRoute
  '/support/how-to-use/instant-buy': typeof SupportHowToUseInstantBuyRoute
  '/support/how-to-use/one-delivery': typeof SupportHowToUseOneDeliveryRoute
  '/support/how-to-use/shop-and-collect': typeof SupportHowToUseShopAndCollectRoute
  '/$hubMetaName/instant-buy/order-summary': typeof HubMetaNameInstantBuyOrderSummaryLazyRoute
  '/$hubMetaName/shop/order-summary': typeof HubMetaNameShopOrderSummaryLazyRoute
  '/$hubMetaName/consultation/': typeof HubMetaNameConsultationIndexRoute
  '/$hubMetaName/instant-buy/': typeof HubMetaNameInstantBuyIndexRoute
  '/$hubMetaName/lock-b2c/': typeof HubMetaNameLockB2cIndexRoute
  '/$hubMetaName/lock/': typeof HubMetaNameLockIndexRoute
  '/$hubMetaName/raffle/': typeof HubMetaNameRaffleIndexRoute
  '/$hubMetaName/shop/': typeof HubMetaNameShopIndexRoute
  '/$hubMetaName/swap/': typeof HubMetaNameSwapIndexRoute
  '/$hubMetaName/warenannahme/': typeof HubMetaNameWarenannahmeIndexRoute
  '/hub/$hubMetaName/': typeof HubHubMetaNameIndexRoute
  '/one-delivery/onboarding/': typeof OneDeliveryOnboardingIndexRoute
  '/support/how-to-use/': typeof SupportHowToUseIndexRoute
  '/$hubMetaName/lock/end-rental/$reservationId': typeof HubMetaNameLockEndRentalReservationIdRoute
  '/$hubMetaName/lock/ended/$reservationId': typeof HubMetaNameLockEndedReservationIdRoute
  '/$hubMetaName/lock/pay/$sessionId': typeof HubMetaNameLockPaySessionIdRoute
  '/$hubMetaName/lock/shared-access/$reservationId': typeof HubMetaNameLockSharedAccessReservationIdRoute
  '/$hubMetaName/lock/summary/$spaceId': typeof HubMetaNameLockSummarySpaceIdRoute
  '/$hubMetaName/raffle/$raffleId/play': typeof HubMetaNameRaffleRaffleIdPlayRoute
  '/$hubMetaName/raffle/$raffleId/result': typeof HubMetaNameRaffleRaffleIdResultRoute
  '/$hubMetaName/raffle/$raffleId/thank-you': typeof HubMetaNameRaffleRaffleIdThankYouRoute
  '/$hubMetaName/swap/end-rental/$reservationId': typeof HubMetaNameSwapEndRentalReservationIdRoute
  '/$hubMetaName/swap/ended/$reservationId': typeof HubMetaNameSwapEndedReservationIdRoute
  '/$hubMetaName/swap/shared-access/$reservationId': typeof HubMetaNameSwapSharedAccessReservationIdRoute
  '/$hubMetaName/swap/summary/$spaceId': typeof HubMetaNameSwapSummarySpaceIdRoute
  '/$hubMetaName/warenannahme/deliver/$spaceId': typeof HubMetaNameWarenannahmeDeliverSpaceIdRoute
  '/$hubMetaName/warenannahme/deliver/': typeof HubMetaNameWarenannahmeDeliverIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/$hubMetaName'
    | '/auth'
    | '/lock-access'
    | '/subscription'
    | '/clickncollect/collect'
    | '/clickncollect/email'
    | '/clickncollect/finish'
    | '/clickncollect/opening'
    | '/one-delivery/collect'
    | '/one-delivery/credits'
    | '/one-delivery/finish'
    | '/one-delivery/new-shipment'
    | '/one-delivery/opening'
    | '/one-delivery/pickup'
    | '/one-delivery/settings'
    | '/profile/change-app-language'
    | '/profile/edit-profile'
    | '/profile/imprint'
    | '/profile/locations'
    | '/profile/payment'
    | '/profile/privacy-policy'
    | '/$hubMetaName/'
    | '/clickncollect/'
    | '/one-delivery/'
    | '/profile/'
    | '/support/'
    | '/$hubMetaName/consultation/contact'
    | '/$hubMetaName/consultation/phone'
    | '/$hubMetaName/lock-b2c/checkout'
    | '/$hubMetaName/lock-b2c/new'
    | '/$hubMetaName/lock/checkout'
    | '/$hubMetaName/lock/coupons'
    | '/$hubMetaName/lock/my'
    | '/$hubMetaName/lock/new'
    | '/$hubMetaName/lock/select'
    | '/$hubMetaName/lock/success'
    | '/$hubMetaName/pick-up/collect'
    | '/$hubMetaName/pick-up/finish'
    | '/$hubMetaName/pick-up/instant-buy'
    | '/$hubMetaName/pick-up/opening'
    | '/$hubMetaName/raffle/another-one-playing'
    | '/$hubMetaName/raffle/no-more-playing'
    | '/$hubMetaName/shop/thank-you'
    | '/$hubMetaName/swap/my'
    | '/$hubMetaName/swap/select'
    | '/$hubMetaName/swap/success'
    | '/$hubMetaName/warenannahme/access'
    | '/$hubMetaName/warenannahme/action'
    | '/$hubMetaName/warenannahme/pickup'
    | '/one-delivery/bundle/$bundleId'
    | '/one-delivery/onboarding/coming-soon'
    | '/one-delivery/onboarding/finish'
    | '/one-delivery/onboarding/pricing'
    | '/one-delivery/onboarding/summary'
    | '/support/how-to-use/click-and-collect'
    | '/support/how-to-use/donations'
    | '/support/how-to-use/instant-buy'
    | '/support/how-to-use/one-delivery'
    | '/support/how-to-use/shop-and-collect'
    | '/$hubMetaName/instant-buy/order-summary'
    | '/$hubMetaName/shop/order-summary'
    | '/$hubMetaName/consultation/'
    | '/$hubMetaName/instant-buy/'
    | '/$hubMetaName/lock-b2c/'
    | '/$hubMetaName/lock/'
    | '/$hubMetaName/raffle/'
    | '/$hubMetaName/shop/'
    | '/$hubMetaName/swap/'
    | '/$hubMetaName/warenannahme/'
    | '/hub/$hubMetaName/'
    | '/one-delivery/onboarding/'
    | '/support/how-to-use/'
    | '/$hubMetaName/lock/end-rental/$reservationId'
    | '/$hubMetaName/lock/ended/$reservationId'
    | '/$hubMetaName/lock/pay/$sessionId'
    | '/$hubMetaName/lock/shared-access/$reservationId'
    | '/$hubMetaName/lock/summary/$spaceId'
    | '/$hubMetaName/raffle/$raffleId/play'
    | '/$hubMetaName/raffle/$raffleId/result'
    | '/$hubMetaName/raffle/$raffleId/thank-you'
    | '/$hubMetaName/swap/end-rental/$reservationId'
    | '/$hubMetaName/swap/ended/$reservationId'
    | '/$hubMetaName/swap/shared-access/$reservationId'
    | '/$hubMetaName/swap/summary/$spaceId'
    | '/$hubMetaName/warenannahme/deliver/$spaceId'
    | '/$hubMetaName/warenannahme/deliver/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/auth'
    | '/lock-access'
    | '/subscription'
    | '/clickncollect/collect'
    | '/clickncollect/email'
    | '/clickncollect/finish'
    | '/clickncollect/opening'
    | '/one-delivery/collect'
    | '/one-delivery/credits'
    | '/one-delivery/finish'
    | '/one-delivery/new-shipment'
    | '/one-delivery/opening'
    | '/one-delivery/pickup'
    | '/one-delivery/settings'
    | '/profile/change-app-language'
    | '/profile/edit-profile'
    | '/profile/imprint'
    | '/profile/locations'
    | '/profile/payment'
    | '/profile/privacy-policy'
    | '/$hubMetaName'
    | '/clickncollect'
    | '/one-delivery'
    | '/profile'
    | '/support'
    | '/$hubMetaName/consultation/contact'
    | '/$hubMetaName/consultation/phone'
    | '/$hubMetaName/lock-b2c/checkout'
    | '/$hubMetaName/lock-b2c/new'
    | '/$hubMetaName/lock/checkout'
    | '/$hubMetaName/lock/coupons'
    | '/$hubMetaName/lock/my'
    | '/$hubMetaName/lock/new'
    | '/$hubMetaName/lock/select'
    | '/$hubMetaName/lock/success'
    | '/$hubMetaName/pick-up/collect'
    | '/$hubMetaName/pick-up/finish'
    | '/$hubMetaName/pick-up/instant-buy'
    | '/$hubMetaName/pick-up/opening'
    | '/$hubMetaName/raffle/another-one-playing'
    | '/$hubMetaName/raffle/no-more-playing'
    | '/$hubMetaName/shop/thank-you'
    | '/$hubMetaName/swap/my'
    | '/$hubMetaName/swap/select'
    | '/$hubMetaName/swap/success'
    | '/$hubMetaName/warenannahme/access'
    | '/$hubMetaName/warenannahme/action'
    | '/$hubMetaName/warenannahme/pickup'
    | '/one-delivery/bundle/$bundleId'
    | '/one-delivery/onboarding/coming-soon'
    | '/one-delivery/onboarding/finish'
    | '/one-delivery/onboarding/pricing'
    | '/one-delivery/onboarding/summary'
    | '/support/how-to-use/click-and-collect'
    | '/support/how-to-use/donations'
    | '/support/how-to-use/instant-buy'
    | '/support/how-to-use/one-delivery'
    | '/support/how-to-use/shop-and-collect'
    | '/$hubMetaName/instant-buy/order-summary'
    | '/$hubMetaName/shop/order-summary'
    | '/$hubMetaName/consultation'
    | '/$hubMetaName/instant-buy'
    | '/$hubMetaName/lock-b2c'
    | '/$hubMetaName/lock'
    | '/$hubMetaName/raffle'
    | '/$hubMetaName/shop'
    | '/$hubMetaName/swap'
    | '/$hubMetaName/warenannahme'
    | '/hub/$hubMetaName'
    | '/one-delivery/onboarding'
    | '/support/how-to-use'
    | '/$hubMetaName/lock/end-rental/$reservationId'
    | '/$hubMetaName/lock/ended/$reservationId'
    | '/$hubMetaName/lock/pay/$sessionId'
    | '/$hubMetaName/lock/shared-access/$reservationId'
    | '/$hubMetaName/lock/summary/$spaceId'
    | '/$hubMetaName/raffle/$raffleId/play'
    | '/$hubMetaName/raffle/$raffleId/result'
    | '/$hubMetaName/raffle/$raffleId/thank-you'
    | '/$hubMetaName/swap/end-rental/$reservationId'
    | '/$hubMetaName/swap/ended/$reservationId'
    | '/$hubMetaName/swap/shared-access/$reservationId'
    | '/$hubMetaName/swap/summary/$spaceId'
    | '/$hubMetaName/warenannahme/deliver/$spaceId'
    | '/$hubMetaName/warenannahme/deliver'
  id:
    | '__root__'
    | '/'
    | '/$hubMetaName'
    | '/auth'
    | '/lock-access'
    | '/subscription'
    | '/clickncollect/collect'
    | '/clickncollect/email'
    | '/clickncollect/finish'
    | '/clickncollect/opening'
    | '/one-delivery/collect'
    | '/one-delivery/credits'
    | '/one-delivery/finish'
    | '/one-delivery/new-shipment'
    | '/one-delivery/opening'
    | '/one-delivery/pickup'
    | '/one-delivery/settings'
    | '/profile/change-app-language'
    | '/profile/edit-profile'
    | '/profile/imprint'
    | '/profile/locations'
    | '/profile/payment'
    | '/profile/privacy-policy'
    | '/$hubMetaName/'
    | '/clickncollect/'
    | '/one-delivery/'
    | '/profile/'
    | '/support/'
    | '/$hubMetaName/consultation/contact'
    | '/$hubMetaName/consultation/phone'
    | '/$hubMetaName/lock-b2c/checkout'
    | '/$hubMetaName/lock-b2c/new'
    | '/$hubMetaName/lock/checkout'
    | '/$hubMetaName/lock/coupons'
    | '/$hubMetaName/lock/my'
    | '/$hubMetaName/lock/new'
    | '/$hubMetaName/lock/select'
    | '/$hubMetaName/lock/success'
    | '/$hubMetaName/pick-up/collect'
    | '/$hubMetaName/pick-up/finish'
    | '/$hubMetaName/pick-up/instant-buy'
    | '/$hubMetaName/pick-up/opening'
    | '/$hubMetaName/raffle/another-one-playing'
    | '/$hubMetaName/raffle/no-more-playing'
    | '/$hubMetaName/shop/thank-you'
    | '/$hubMetaName/swap/my'
    | '/$hubMetaName/swap/select'
    | '/$hubMetaName/swap/success'
    | '/$hubMetaName/warenannahme/access'
    | '/$hubMetaName/warenannahme/action'
    | '/$hubMetaName/warenannahme/pickup'
    | '/one-delivery/bundle/$bundleId'
    | '/one-delivery/onboarding/coming-soon'
    | '/one-delivery/onboarding/finish'
    | '/one-delivery/onboarding/pricing'
    | '/one-delivery/onboarding/summary'
    | '/support/how-to-use/click-and-collect'
    | '/support/how-to-use/donations'
    | '/support/how-to-use/instant-buy'
    | '/support/how-to-use/one-delivery'
    | '/support/how-to-use/shop-and-collect'
    | '/$hubMetaName/instant-buy/order-summary'
    | '/$hubMetaName/shop/order-summary'
    | '/$hubMetaName/consultation/'
    | '/$hubMetaName/instant-buy/'
    | '/$hubMetaName/lock-b2c/'
    | '/$hubMetaName/lock/'
    | '/$hubMetaName/raffle/'
    | '/$hubMetaName/shop/'
    | '/$hubMetaName/swap/'
    | '/$hubMetaName/warenannahme/'
    | '/hub/$hubMetaName/'
    | '/one-delivery/onboarding/'
    | '/support/how-to-use/'
    | '/$hubMetaName/lock/end-rental/$reservationId'
    | '/$hubMetaName/lock/ended/$reservationId'
    | '/$hubMetaName/lock/pay/$sessionId'
    | '/$hubMetaName/lock/shared-access/$reservationId'
    | '/$hubMetaName/lock/summary/$spaceId'
    | '/$hubMetaName/raffle/$raffleId/play'
    | '/$hubMetaName/raffle/$raffleId/result'
    | '/$hubMetaName/raffle/$raffleId/thank-you'
    | '/$hubMetaName/swap/end-rental/$reservationId'
    | '/$hubMetaName/swap/ended/$reservationId'
    | '/$hubMetaName/swap/shared-access/$reservationId'
    | '/$hubMetaName/swap/summary/$spaceId'
    | '/$hubMetaName/warenannahme/deliver/$spaceId'
    | '/$hubMetaName/warenannahme/deliver/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  HubMetaNameRouteRoute: typeof HubMetaNameRouteRouteWithChildren
  AuthRoute: typeof AuthRoute
  LockAccessRoute: typeof LockAccessRoute
  SubscriptionRoute: typeof SubscriptionRoute
  ClickncollectCollectRoute: typeof ClickncollectCollectRoute
  ClickncollectEmailRoute: typeof ClickncollectEmailRoute
  ClickncollectFinishRoute: typeof ClickncollectFinishRoute
  ClickncollectOpeningRoute: typeof ClickncollectOpeningRoute
  OneDeliveryCollectRoute: typeof OneDeliveryCollectRoute
  OneDeliveryCreditsRoute: typeof OneDeliveryCreditsRoute
  OneDeliveryFinishRoute: typeof OneDeliveryFinishRoute
  OneDeliveryNewShipmentRoute: typeof OneDeliveryNewShipmentRoute
  OneDeliveryOpeningRoute: typeof OneDeliveryOpeningRoute
  OneDeliveryPickupRoute: typeof OneDeliveryPickupRoute
  OneDeliverySettingsRoute: typeof OneDeliverySettingsRoute
  ProfileChangeAppLanguageRoute: typeof ProfileChangeAppLanguageRoute
  ProfileEditProfileRoute: typeof ProfileEditProfileRoute
  ProfileImprintRoute: typeof ProfileImprintRoute
  ProfileLocationsRoute: typeof ProfileLocationsRoute
  ProfilePaymentRoute: typeof ProfilePaymentRoute
  ProfilePrivacyPolicyRoute: typeof ProfilePrivacyPolicyRoute
  ClickncollectIndexRoute: typeof ClickncollectIndexRoute
  OneDeliveryIndexRoute: typeof OneDeliveryIndexRoute
  ProfileIndexRoute: typeof ProfileIndexRoute
  SupportIndexRoute: typeof SupportIndexRoute
  OneDeliveryBundleBundleIdRoute: typeof OneDeliveryBundleBundleIdRoute
  OneDeliveryOnboardingComingSoonRoute: typeof OneDeliveryOnboardingComingSoonRoute
  OneDeliveryOnboardingFinishRoute: typeof OneDeliveryOnboardingFinishRoute
  OneDeliveryOnboardingPricingRoute: typeof OneDeliveryOnboardingPricingRoute
  OneDeliveryOnboardingSummaryRoute: typeof OneDeliveryOnboardingSummaryRoute
  SupportHowToUseClickAndCollectRoute: typeof SupportHowToUseClickAndCollectRoute
  SupportHowToUseDonationsRoute: typeof SupportHowToUseDonationsRoute
  SupportHowToUseInstantBuyRoute: typeof SupportHowToUseInstantBuyRoute
  SupportHowToUseOneDeliveryRoute: typeof SupportHowToUseOneDeliveryRoute
  SupportHowToUseShopAndCollectRoute: typeof SupportHowToUseShopAndCollectRoute
  HubHubMetaNameIndexRoute: typeof HubHubMetaNameIndexRoute
  OneDeliveryOnboardingIndexRoute: typeof OneDeliveryOnboardingIndexRoute
  SupportHowToUseIndexRoute: typeof SupportHowToUseIndexRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/subscription': {
      id: '/subscription'
      path: '/subscription'
      fullPath: '/subscription'
      preLoaderRoute: typeof SubscriptionRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/lock-access': {
      id: '/lock-access'
      path: '/lock-access'
      fullPath: '/lock-access'
      preLoaderRoute: typeof LockAccessRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auth': {
      id: '/auth'
      path: '/auth'
      fullPath: '/auth'
      preLoaderRoute: typeof AuthRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/$hubMetaName': {
      id: '/$hubMetaName'
      path: '/$hubMetaName'
      fullPath: '/$hubMetaName'
      preLoaderRoute: typeof HubMetaNameRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/support/': {
      id: '/support/'
      path: '/support'
      fullPath: '/support/'
      preLoaderRoute: typeof SupportIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/profile/': {
      id: '/profile/'
      path: '/profile'
      fullPath: '/profile/'
      preLoaderRoute: typeof ProfileIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/one-delivery/': {
      id: '/one-delivery/'
      path: '/one-delivery'
      fullPath: '/one-delivery/'
      preLoaderRoute: typeof OneDeliveryIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/clickncollect/': {
      id: '/clickncollect/'
      path: '/clickncollect'
      fullPath: '/clickncollect/'
      preLoaderRoute: typeof ClickncollectIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/$hubMetaName/': {
      id: '/$hubMetaName/'
      path: '/'
      fullPath: '/$hubMetaName/'
      preLoaderRoute: typeof HubMetaNameIndexRouteImport
      parentRoute: typeof HubMetaNameRouteRoute
    }
    '/profile/privacy-policy': {
      id: '/profile/privacy-policy'
      path: '/profile/privacy-policy'
      fullPath: '/profile/privacy-policy'
      preLoaderRoute: typeof ProfilePrivacyPolicyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/profile/payment': {
      id: '/profile/payment'
      path: '/profile/payment'
      fullPath: '/profile/payment'
      preLoaderRoute: typeof ProfilePaymentRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/profile/locations': {
      id: '/profile/locations'
      path: '/profile/locations'
      fullPath: '/profile/locations'
      preLoaderRoute: typeof ProfileLocationsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/profile/imprint': {
      id: '/profile/imprint'
      path: '/profile/imprint'
      fullPath: '/profile/imprint'
      preLoaderRoute: typeof ProfileImprintRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/profile/edit-profile': {
      id: '/profile/edit-profile'
      path: '/profile/edit-profile'
      fullPath: '/profile/edit-profile'
      preLoaderRoute: typeof ProfileEditProfileRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/profile/change-app-language': {
      id: '/profile/change-app-language'
      path: '/profile/change-app-language'
      fullPath: '/profile/change-app-language'
      preLoaderRoute: typeof ProfileChangeAppLanguageRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/one-delivery/settings': {
      id: '/one-delivery/settings'
      path: '/one-delivery/settings'
      fullPath: '/one-delivery/settings'
      preLoaderRoute: typeof OneDeliverySettingsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/one-delivery/pickup': {
      id: '/one-delivery/pickup'
      path: '/one-delivery/pickup'
      fullPath: '/one-delivery/pickup'
      preLoaderRoute: typeof OneDeliveryPickupRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/one-delivery/opening': {
      id: '/one-delivery/opening'
      path: '/one-delivery/opening'
      fullPath: '/one-delivery/opening'
      preLoaderRoute: typeof OneDeliveryOpeningRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/one-delivery/new-shipment': {
      id: '/one-delivery/new-shipment'
      path: '/one-delivery/new-shipment'
      fullPath: '/one-delivery/new-shipment'
      preLoaderRoute: typeof OneDeliveryNewShipmentRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/one-delivery/finish': {
      id: '/one-delivery/finish'
      path: '/one-delivery/finish'
      fullPath: '/one-delivery/finish'
      preLoaderRoute: typeof OneDeliveryFinishRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/one-delivery/credits': {
      id: '/one-delivery/credits'
      path: '/one-delivery/credits'
      fullPath: '/one-delivery/credits'
      preLoaderRoute: typeof OneDeliveryCreditsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/one-delivery/collect': {
      id: '/one-delivery/collect'
      path: '/one-delivery/collect'
      fullPath: '/one-delivery/collect'
      preLoaderRoute: typeof OneDeliveryCollectRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/clickncollect/opening': {
      id: '/clickncollect/opening'
      path: '/clickncollect/opening'
      fullPath: '/clickncollect/opening'
      preLoaderRoute: typeof ClickncollectOpeningRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/clickncollect/finish': {
      id: '/clickncollect/finish'
      path: '/clickncollect/finish'
      fullPath: '/clickncollect/finish'
      preLoaderRoute: typeof ClickncollectFinishRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/clickncollect/email': {
      id: '/clickncollect/email'
      path: '/clickncollect/email'
      fullPath: '/clickncollect/email'
      preLoaderRoute: typeof ClickncollectEmailRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/clickncollect/collect': {
      id: '/clickncollect/collect'
      path: '/clickncollect/collect'
      fullPath: '/clickncollect/collect'
      preLoaderRoute: typeof ClickncollectCollectRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/support/how-to-use/': {
      id: '/support/how-to-use/'
      path: '/support/how-to-use'
      fullPath: '/support/how-to-use/'
      preLoaderRoute: typeof SupportHowToUseIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/one-delivery/onboarding/': {
      id: '/one-delivery/onboarding/'
      path: '/one-delivery/onboarding'
      fullPath: '/one-delivery/onboarding/'
      preLoaderRoute: typeof OneDeliveryOnboardingIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/hub/$hubMetaName/': {
      id: '/hub/$hubMetaName/'
      path: '/hub/$hubMetaName'
      fullPath: '/hub/$hubMetaName/'
      preLoaderRoute: typeof HubHubMetaNameIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/$hubMetaName/warenannahme/': {
      id: '/$hubMetaName/warenannahme/'
      path: '/warenannahme'
      fullPath: '/$hubMetaName/warenannahme/'
      preLoaderRoute: typeof HubMetaNameWarenannahmeIndexRouteImport
      parentRoute: typeof HubMetaNameRouteRoute
    }
    '/$hubMetaName/swap/': {
      id: '/$hubMetaName/swap/'
      path: '/swap'
      fullPath: '/$hubMetaName/swap/'
      preLoaderRoute: typeof HubMetaNameSwapIndexRouteImport
      parentRoute: typeof HubMetaNameRouteRoute
    }
    '/$hubMetaName/shop/': {
      id: '/$hubMetaName/shop/'
      path: '/shop'
      fullPath: '/$hubMetaName/shop/'
      preLoaderRoute: typeof HubMetaNameShopIndexRouteImport
      parentRoute: typeof HubMetaNameRouteRoute
    }
    '/$hubMetaName/raffle/': {
      id: '/$hubMetaName/raffle/'
      path: '/raffle'
      fullPath: '/$hubMetaName/raffle/'
      preLoaderRoute: typeof HubMetaNameRaffleIndexRouteImport
      parentRoute: typeof HubMetaNameRouteRoute
    }
    '/$hubMetaName/lock/': {
      id: '/$hubMetaName/lock/'
      path: '/lock'
      fullPath: '/$hubMetaName/lock/'
      preLoaderRoute: typeof HubMetaNameLockIndexRouteImport
      parentRoute: typeof HubMetaNameRouteRoute
    }
    '/$hubMetaName/lock-b2c/': {
      id: '/$hubMetaName/lock-b2c/'
      path: '/lock-b2c'
      fullPath: '/$hubMetaName/lock-b2c/'
      preLoaderRoute: typeof HubMetaNameLockB2cIndexRouteImport
      parentRoute: typeof HubMetaNameRouteRoute
    }
    '/$hubMetaName/instant-buy/': {
      id: '/$hubMetaName/instant-buy/'
      path: '/instant-buy'
      fullPath: '/$hubMetaName/instant-buy/'
      preLoaderRoute: typeof HubMetaNameInstantBuyIndexRouteImport
      parentRoute: typeof HubMetaNameRouteRoute
    }
    '/$hubMetaName/consultation/': {
      id: '/$hubMetaName/consultation/'
      path: '/consultation'
      fullPath: '/$hubMetaName/consultation/'
      preLoaderRoute: typeof HubMetaNameConsultationIndexRouteImport
      parentRoute: typeof HubMetaNameRouteRoute
    }
    '/$hubMetaName/shop/order-summary': {
      id: '/$hubMetaName/shop/order-summary'
      path: '/shop/order-summary'
      fullPath: '/$hubMetaName/shop/order-summary'
      preLoaderRoute: typeof HubMetaNameShopOrderSummaryLazyRouteImport
      parentRoute: typeof HubMetaNameRouteRoute
    }
    '/$hubMetaName/instant-buy/order-summary': {
      id: '/$hubMetaName/instant-buy/order-summary'
      path: '/instant-buy/order-summary'
      fullPath: '/$hubMetaName/instant-buy/order-summary'
      preLoaderRoute: typeof HubMetaNameInstantBuyOrderSummaryLazyRouteImport
      parentRoute: typeof HubMetaNameRouteRoute
    }
    '/support/how-to-use/shop-and-collect': {
      id: '/support/how-to-use/shop-and-collect'
      path: '/support/how-to-use/shop-and-collect'
      fullPath: '/support/how-to-use/shop-and-collect'
      preLoaderRoute: typeof SupportHowToUseShopAndCollectRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/support/how-to-use/one-delivery': {
      id: '/support/how-to-use/one-delivery'
      path: '/support/how-to-use/one-delivery'
      fullPath: '/support/how-to-use/one-delivery'
      preLoaderRoute: typeof SupportHowToUseOneDeliveryRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/support/how-to-use/instant-buy': {
      id: '/support/how-to-use/instant-buy'
      path: '/support/how-to-use/instant-buy'
      fullPath: '/support/how-to-use/instant-buy'
      preLoaderRoute: typeof SupportHowToUseInstantBuyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/support/how-to-use/donations': {
      id: '/support/how-to-use/donations'
      path: '/support/how-to-use/donations'
      fullPath: '/support/how-to-use/donations'
      preLoaderRoute: typeof SupportHowToUseDonationsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/support/how-to-use/click-and-collect': {
      id: '/support/how-to-use/click-and-collect'
      path: '/support/how-to-use/click-and-collect'
      fullPath: '/support/how-to-use/click-and-collect'
      preLoaderRoute: typeof SupportHowToUseClickAndCollectRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/one-delivery/onboarding/summary': {
      id: '/one-delivery/onboarding/summary'
      path: '/one-delivery/onboarding/summary'
      fullPath: '/one-delivery/onboarding/summary'
      preLoaderRoute: typeof OneDeliveryOnboardingSummaryRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/one-delivery/onboarding/pricing': {
      id: '/one-delivery/onboarding/pricing'
      path: '/one-delivery/onboarding/pricing'
      fullPath: '/one-delivery/onboarding/pricing'
      preLoaderRoute: typeof OneDeliveryOnboardingPricingRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/one-delivery/onboarding/finish': {
      id: '/one-delivery/onboarding/finish'
      path: '/one-delivery/onboarding/finish'
      fullPath: '/one-delivery/onboarding/finish'
      preLoaderRoute: typeof OneDeliveryOnboardingFinishRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/one-delivery/onboarding/coming-soon': {
      id: '/one-delivery/onboarding/coming-soon'
      path: '/one-delivery/onboarding/coming-soon'
      fullPath: '/one-delivery/onboarding/coming-soon'
      preLoaderRoute: typeof OneDeliveryOnboardingComingSoonRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/one-delivery/bundle/$bundleId': {
      id: '/one-delivery/bundle/$bundleId'
      path: '/one-delivery/bundle/$bundleId'
      fullPath: '/one-delivery/bundle/$bundleId'
      preLoaderRoute: typeof OneDeliveryBundleBundleIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/$hubMetaName/warenannahme/pickup': {
      id: '/$hubMetaName/warenannahme/pickup'
      path: '/warenannahme/pickup'
      fullPath: '/$hubMetaName/warenannahme/pickup'
      preLoaderRoute: typeof HubMetaNameWarenannahmePickupRouteImport
      parentRoute: typeof HubMetaNameRouteRoute
    }
    '/$hubMetaName/warenannahme/action': {
      id: '/$hubMetaName/warenannahme/action'
      path: '/warenannahme/action'
      fullPath: '/$hubMetaName/warenannahme/action'
      preLoaderRoute: typeof HubMetaNameWarenannahmeActionRouteImport
      parentRoute: typeof HubMetaNameRouteRoute
    }
    '/$hubMetaName/warenannahme/access': {
      id: '/$hubMetaName/warenannahme/access'
      path: '/warenannahme/access'
      fullPath: '/$hubMetaName/warenannahme/access'
      preLoaderRoute: typeof HubMetaNameWarenannahmeAccessRouteImport
      parentRoute: typeof HubMetaNameRouteRoute
    }
    '/$hubMetaName/swap/success': {
      id: '/$hubMetaName/swap/success'
      path: '/swap/success'
      fullPath: '/$hubMetaName/swap/success'
      preLoaderRoute: typeof HubMetaNameSwapSuccessRouteImport
      parentRoute: typeof HubMetaNameRouteRoute
    }
    '/$hubMetaName/swap/select': {
      id: '/$hubMetaName/swap/select'
      path: '/swap/select'
      fullPath: '/$hubMetaName/swap/select'
      preLoaderRoute: typeof HubMetaNameSwapSelectRouteImport
      parentRoute: typeof HubMetaNameRouteRoute
    }
    '/$hubMetaName/swap/my': {
      id: '/$hubMetaName/swap/my'
      path: '/swap/my'
      fullPath: '/$hubMetaName/swap/my'
      preLoaderRoute: typeof HubMetaNameSwapMyRouteImport
      parentRoute: typeof HubMetaNameRouteRoute
    }
    '/$hubMetaName/shop/thank-you': {
      id: '/$hubMetaName/shop/thank-you'
      path: '/shop/thank-you'
      fullPath: '/$hubMetaName/shop/thank-you'
      preLoaderRoute: typeof HubMetaNameShopThankYouRouteImport
      parentRoute: typeof HubMetaNameRouteRoute
    }
    '/$hubMetaName/raffle/no-more-playing': {
      id: '/$hubMetaName/raffle/no-more-playing'
      path: '/raffle/no-more-playing'
      fullPath: '/$hubMetaName/raffle/no-more-playing'
      preLoaderRoute: typeof HubMetaNameRaffleNoMorePlayingRouteImport
      parentRoute: typeof HubMetaNameRouteRoute
    }
    '/$hubMetaName/raffle/another-one-playing': {
      id: '/$hubMetaName/raffle/another-one-playing'
      path: '/raffle/another-one-playing'
      fullPath: '/$hubMetaName/raffle/another-one-playing'
      preLoaderRoute: typeof HubMetaNameRaffleAnotherOnePlayingRouteImport
      parentRoute: typeof HubMetaNameRouteRoute
    }
    '/$hubMetaName/pick-up/opening': {
      id: '/$hubMetaName/pick-up/opening'
      path: '/pick-up/opening'
      fullPath: '/$hubMetaName/pick-up/opening'
      preLoaderRoute: typeof HubMetaNamePickUpOpeningRouteImport
      parentRoute: typeof HubMetaNameRouteRoute
    }
    '/$hubMetaName/pick-up/instant-buy': {
      id: '/$hubMetaName/pick-up/instant-buy'
      path: '/pick-up/instant-buy'
      fullPath: '/$hubMetaName/pick-up/instant-buy'
      preLoaderRoute: typeof HubMetaNamePickUpInstantBuyRouteImport
      parentRoute: typeof HubMetaNameRouteRoute
    }
    '/$hubMetaName/pick-up/finish': {
      id: '/$hubMetaName/pick-up/finish'
      path: '/pick-up/finish'
      fullPath: '/$hubMetaName/pick-up/finish'
      preLoaderRoute: typeof HubMetaNamePickUpFinishRouteImport
      parentRoute: typeof HubMetaNameRouteRoute
    }
    '/$hubMetaName/pick-up/collect': {
      id: '/$hubMetaName/pick-up/collect'
      path: '/pick-up/collect'
      fullPath: '/$hubMetaName/pick-up/collect'
      preLoaderRoute: typeof HubMetaNamePickUpCollectRouteImport
      parentRoute: typeof HubMetaNameRouteRoute
    }
    '/$hubMetaName/lock/success': {
      id: '/$hubMetaName/lock/success'
      path: '/lock/success'
      fullPath: '/$hubMetaName/lock/success'
      preLoaderRoute: typeof HubMetaNameLockSuccessRouteImport
      parentRoute: typeof HubMetaNameRouteRoute
    }
    '/$hubMetaName/lock/select': {
      id: '/$hubMetaName/lock/select'
      path: '/lock/select'
      fullPath: '/$hubMetaName/lock/select'
      preLoaderRoute: typeof HubMetaNameLockSelectRouteImport
      parentRoute: typeof HubMetaNameRouteRoute
    }
    '/$hubMetaName/lock/new': {
      id: '/$hubMetaName/lock/new'
      path: '/lock/new'
      fullPath: '/$hubMetaName/lock/new'
      preLoaderRoute: typeof HubMetaNameLockNewRouteImport
      parentRoute: typeof HubMetaNameRouteRoute
    }
    '/$hubMetaName/lock/my': {
      id: '/$hubMetaName/lock/my'
      path: '/lock/my'
      fullPath: '/$hubMetaName/lock/my'
      preLoaderRoute: typeof HubMetaNameLockMyRouteImport
      parentRoute: typeof HubMetaNameRouteRoute
    }
    '/$hubMetaName/lock/coupons': {
      id: '/$hubMetaName/lock/coupons'
      path: '/lock/coupons'
      fullPath: '/$hubMetaName/lock/coupons'
      preLoaderRoute: typeof HubMetaNameLockCouponsRouteImport
      parentRoute: typeof HubMetaNameRouteRoute
    }
    '/$hubMetaName/lock/checkout': {
      id: '/$hubMetaName/lock/checkout'
      path: '/lock/checkout'
      fullPath: '/$hubMetaName/lock/checkout'
      preLoaderRoute: typeof HubMetaNameLockCheckoutRouteImport
      parentRoute: typeof HubMetaNameRouteRoute
    }
    '/$hubMetaName/lock-b2c/new': {
      id: '/$hubMetaName/lock-b2c/new'
      path: '/lock-b2c/new'
      fullPath: '/$hubMetaName/lock-b2c/new'
      preLoaderRoute: typeof HubMetaNameLockB2cNewRouteImport
      parentRoute: typeof HubMetaNameRouteRoute
    }
    '/$hubMetaName/lock-b2c/checkout': {
      id: '/$hubMetaName/lock-b2c/checkout'
      path: '/lock-b2c/checkout'
      fullPath: '/$hubMetaName/lock-b2c/checkout'
      preLoaderRoute: typeof HubMetaNameLockB2cCheckoutRouteImport
      parentRoute: typeof HubMetaNameRouteRoute
    }
    '/$hubMetaName/consultation/phone': {
      id: '/$hubMetaName/consultation/phone'
      path: '/consultation/phone'
      fullPath: '/$hubMetaName/consultation/phone'
      preLoaderRoute: typeof HubMetaNameConsultationPhoneRouteImport
      parentRoute: typeof HubMetaNameRouteRoute
    }
    '/$hubMetaName/consultation/contact': {
      id: '/$hubMetaName/consultation/contact'
      path: '/consultation/contact'
      fullPath: '/$hubMetaName/consultation/contact'
      preLoaderRoute: typeof HubMetaNameConsultationContactRouteImport
      parentRoute: typeof HubMetaNameRouteRoute
    }
    '/$hubMetaName/warenannahme/deliver/': {
      id: '/$hubMetaName/warenannahme/deliver/'
      path: '/warenannahme/deliver'
      fullPath: '/$hubMetaName/warenannahme/deliver/'
      preLoaderRoute: typeof HubMetaNameWarenannahmeDeliverIndexRouteImport
      parentRoute: typeof HubMetaNameRouteRoute
    }
    '/$hubMetaName/warenannahme/deliver/$spaceId': {
      id: '/$hubMetaName/warenannahme/deliver/$spaceId'
      path: '/warenannahme/deliver/$spaceId'
      fullPath: '/$hubMetaName/warenannahme/deliver/$spaceId'
      preLoaderRoute: typeof HubMetaNameWarenannahmeDeliverSpaceIdRouteImport
      parentRoute: typeof HubMetaNameRouteRoute
    }
    '/$hubMetaName/swap/summary/$spaceId': {
      id: '/$hubMetaName/swap/summary/$spaceId'
      path: '/swap/summary/$spaceId'
      fullPath: '/$hubMetaName/swap/summary/$spaceId'
      preLoaderRoute: typeof HubMetaNameSwapSummarySpaceIdRouteImport
      parentRoute: typeof HubMetaNameRouteRoute
    }
    '/$hubMetaName/swap/shared-access/$reservationId': {
      id: '/$hubMetaName/swap/shared-access/$reservationId'
      path: '/swap/shared-access/$reservationId'
      fullPath: '/$hubMetaName/swap/shared-access/$reservationId'
      preLoaderRoute: typeof HubMetaNameSwapSharedAccessReservationIdRouteImport
      parentRoute: typeof HubMetaNameRouteRoute
    }
    '/$hubMetaName/swap/ended/$reservationId': {
      id: '/$hubMetaName/swap/ended/$reservationId'
      path: '/swap/ended/$reservationId'
      fullPath: '/$hubMetaName/swap/ended/$reservationId'
      preLoaderRoute: typeof HubMetaNameSwapEndedReservationIdRouteImport
      parentRoute: typeof HubMetaNameRouteRoute
    }
    '/$hubMetaName/swap/end-rental/$reservationId': {
      id: '/$hubMetaName/swap/end-rental/$reservationId'
      path: '/swap/end-rental/$reservationId'
      fullPath: '/$hubMetaName/swap/end-rental/$reservationId'
      preLoaderRoute: typeof HubMetaNameSwapEndRentalReservationIdRouteImport
      parentRoute: typeof HubMetaNameRouteRoute
    }
    '/$hubMetaName/raffle/$raffleId/thank-you': {
      id: '/$hubMetaName/raffle/$raffleId/thank-you'
      path: '/raffle/$raffleId/thank-you'
      fullPath: '/$hubMetaName/raffle/$raffleId/thank-you'
      preLoaderRoute: typeof HubMetaNameRaffleRaffleIdThankYouRouteImport
      parentRoute: typeof HubMetaNameRouteRoute
    }
    '/$hubMetaName/raffle/$raffleId/result': {
      id: '/$hubMetaName/raffle/$raffleId/result'
      path: '/raffle/$raffleId/result'
      fullPath: '/$hubMetaName/raffle/$raffleId/result'
      preLoaderRoute: typeof HubMetaNameRaffleRaffleIdResultRouteImport
      parentRoute: typeof HubMetaNameRouteRoute
    }
    '/$hubMetaName/raffle/$raffleId/play': {
      id: '/$hubMetaName/raffle/$raffleId/play'
      path: '/raffle/$raffleId/play'
      fullPath: '/$hubMetaName/raffle/$raffleId/play'
      preLoaderRoute: typeof HubMetaNameRaffleRaffleIdPlayRouteImport
      parentRoute: typeof HubMetaNameRouteRoute
    }
    '/$hubMetaName/lock/summary/$spaceId': {
      id: '/$hubMetaName/lock/summary/$spaceId'
      path: '/lock/summary/$spaceId'
      fullPath: '/$hubMetaName/lock/summary/$spaceId'
      preLoaderRoute: typeof HubMetaNameLockSummarySpaceIdRouteImport
      parentRoute: typeof HubMetaNameRouteRoute
    }
    '/$hubMetaName/lock/shared-access/$reservationId': {
      id: '/$hubMetaName/lock/shared-access/$reservationId'
      path: '/lock/shared-access/$reservationId'
      fullPath: '/$hubMetaName/lock/shared-access/$reservationId'
      preLoaderRoute: typeof HubMetaNameLockSharedAccessReservationIdRouteImport
      parentRoute: typeof HubMetaNameRouteRoute
    }
    '/$hubMetaName/lock/pay/$sessionId': {
      id: '/$hubMetaName/lock/pay/$sessionId'
      path: '/lock/pay/$sessionId'
      fullPath: '/$hubMetaName/lock/pay/$sessionId'
      preLoaderRoute: typeof HubMetaNameLockPaySessionIdRouteImport
      parentRoute: typeof HubMetaNameRouteRoute
    }
    '/$hubMetaName/lock/ended/$reservationId': {
      id: '/$hubMetaName/lock/ended/$reservationId'
      path: '/lock/ended/$reservationId'
      fullPath: '/$hubMetaName/lock/ended/$reservationId'
      preLoaderRoute: typeof HubMetaNameLockEndedReservationIdRouteImport
      parentRoute: typeof HubMetaNameRouteRoute
    }
    '/$hubMetaName/lock/end-rental/$reservationId': {
      id: '/$hubMetaName/lock/end-rental/$reservationId'
      path: '/lock/end-rental/$reservationId'
      fullPath: '/$hubMetaName/lock/end-rental/$reservationId'
      preLoaderRoute: typeof HubMetaNameLockEndRentalReservationIdRouteImport
      parentRoute: typeof HubMetaNameRouteRoute
    }
  }
}

interface HubMetaNameRouteRouteChildren {
  HubMetaNameIndexRoute: typeof HubMetaNameIndexRoute
  HubMetaNameConsultationContactRoute: typeof HubMetaNameConsultationContactRoute
  HubMetaNameConsultationPhoneRoute: typeof HubMetaNameConsultationPhoneRoute
  HubMetaNameLockB2cCheckoutRoute: typeof HubMetaNameLockB2cCheckoutRoute
  HubMetaNameLockB2cNewRoute: typeof HubMetaNameLockB2cNewRoute
  HubMetaNameLockCheckoutRoute: typeof HubMetaNameLockCheckoutRoute
  HubMetaNameLockCouponsRoute: typeof HubMetaNameLockCouponsRoute
  HubMetaNameLockMyRoute: typeof HubMetaNameLockMyRoute
  HubMetaNameLockNewRoute: typeof HubMetaNameLockNewRoute
  HubMetaNameLockSelectRoute: typeof HubMetaNameLockSelectRoute
  HubMetaNameLockSuccessRoute: typeof HubMetaNameLockSuccessRoute
  HubMetaNamePickUpCollectRoute: typeof HubMetaNamePickUpCollectRoute
  HubMetaNamePickUpFinishRoute: typeof HubMetaNamePickUpFinishRoute
  HubMetaNamePickUpInstantBuyRoute: typeof HubMetaNamePickUpInstantBuyRoute
  HubMetaNamePickUpOpeningRoute: typeof HubMetaNamePickUpOpeningRoute
  HubMetaNameRaffleAnotherOnePlayingRoute: typeof HubMetaNameRaffleAnotherOnePlayingRoute
  HubMetaNameRaffleNoMorePlayingRoute: typeof HubMetaNameRaffleNoMorePlayingRoute
  HubMetaNameShopThankYouRoute: typeof HubMetaNameShopThankYouRoute
  HubMetaNameSwapMyRoute: typeof HubMetaNameSwapMyRoute
  HubMetaNameSwapSelectRoute: typeof HubMetaNameSwapSelectRoute
  HubMetaNameSwapSuccessRoute: typeof HubMetaNameSwapSuccessRoute
  HubMetaNameWarenannahmeAccessRoute: typeof HubMetaNameWarenannahmeAccessRoute
  HubMetaNameWarenannahmeActionRoute: typeof HubMetaNameWarenannahmeActionRoute
  HubMetaNameWarenannahmePickupRoute: typeof HubMetaNameWarenannahmePickupRoute
  HubMetaNameInstantBuyOrderSummaryLazyRoute: typeof HubMetaNameInstantBuyOrderSummaryLazyRoute
  HubMetaNameShopOrderSummaryLazyRoute: typeof HubMetaNameShopOrderSummaryLazyRoute
  HubMetaNameConsultationIndexRoute: typeof HubMetaNameConsultationIndexRoute
  HubMetaNameInstantBuyIndexRoute: typeof HubMetaNameInstantBuyIndexRoute
  HubMetaNameLockB2cIndexRoute: typeof HubMetaNameLockB2cIndexRoute
  HubMetaNameLockIndexRoute: typeof HubMetaNameLockIndexRoute
  HubMetaNameRaffleIndexRoute: typeof HubMetaNameRaffleIndexRoute
  HubMetaNameShopIndexRoute: typeof HubMetaNameShopIndexRoute
  HubMetaNameSwapIndexRoute: typeof HubMetaNameSwapIndexRoute
  HubMetaNameWarenannahmeIndexRoute: typeof HubMetaNameWarenannahmeIndexRoute
  HubMetaNameLockEndRentalReservationIdRoute: typeof HubMetaNameLockEndRentalReservationIdRoute
  HubMetaNameLockEndedReservationIdRoute: typeof HubMetaNameLockEndedReservationIdRoute
  HubMetaNameLockPaySessionIdRoute: typeof HubMetaNameLockPaySessionIdRoute
  HubMetaNameLockSharedAccessReservationIdRoute: typeof HubMetaNameLockSharedAccessReservationIdRoute
  HubMetaNameLockSummarySpaceIdRoute: typeof HubMetaNameLockSummarySpaceIdRoute
  HubMetaNameRaffleRaffleIdPlayRoute: typeof HubMetaNameRaffleRaffleIdPlayRoute
  HubMetaNameRaffleRaffleIdResultRoute: typeof HubMetaNameRaffleRaffleIdResultRoute
  HubMetaNameRaffleRaffleIdThankYouRoute: typeof HubMetaNameRaffleRaffleIdThankYouRoute
  HubMetaNameSwapEndRentalReservationIdRoute: typeof HubMetaNameSwapEndRentalReservationIdRoute
  HubMetaNameSwapEndedReservationIdRoute: typeof HubMetaNameSwapEndedReservationIdRoute
  HubMetaNameSwapSharedAccessReservationIdRoute: typeof HubMetaNameSwapSharedAccessReservationIdRoute
  HubMetaNameSwapSummarySpaceIdRoute: typeof HubMetaNameSwapSummarySpaceIdRoute
  HubMetaNameWarenannahmeDeliverSpaceIdRoute: typeof HubMetaNameWarenannahmeDeliverSpaceIdRoute
  HubMetaNameWarenannahmeDeliverIndexRoute: typeof HubMetaNameWarenannahmeDeliverIndexRoute
}

const HubMetaNameRouteRouteChildren: HubMetaNameRouteRouteChildren = {
  HubMetaNameIndexRoute: HubMetaNameIndexRoute,
  HubMetaNameConsultationContactRoute: HubMetaNameConsultationContactRoute,
  HubMetaNameConsultationPhoneRoute: HubMetaNameConsultationPhoneRoute,
  HubMetaNameLockB2cCheckoutRoute: HubMetaNameLockB2cCheckoutRoute,
  HubMetaNameLockB2cNewRoute: HubMetaNameLockB2cNewRoute,
  HubMetaNameLockCheckoutRoute: HubMetaNameLockCheckoutRoute,
  HubMetaNameLockCouponsRoute: HubMetaNameLockCouponsRoute,
  HubMetaNameLockMyRoute: HubMetaNameLockMyRoute,
  HubMetaNameLockNewRoute: HubMetaNameLockNewRoute,
  HubMetaNameLockSelectRoute: HubMetaNameLockSelectRoute,
  HubMetaNameLockSuccessRoute: HubMetaNameLockSuccessRoute,
  HubMetaNamePickUpCollectRoute: HubMetaNamePickUpCollectRoute,
  HubMetaNamePickUpFinishRoute: HubMetaNamePickUpFinishRoute,
  HubMetaNamePickUpInstantBuyRoute: HubMetaNamePickUpInstantBuyRoute,
  HubMetaNamePickUpOpeningRoute: HubMetaNamePickUpOpeningRoute,
  HubMetaNameRaffleAnotherOnePlayingRoute:
    HubMetaNameRaffleAnotherOnePlayingRoute,
  HubMetaNameRaffleNoMorePlayingRoute: HubMetaNameRaffleNoMorePlayingRoute,
  HubMetaNameShopThankYouRoute: HubMetaNameShopThankYouRoute,
  HubMetaNameSwapMyRoute: HubMetaNameSwapMyRoute,
  HubMetaNameSwapSelectRoute: HubMetaNameSwapSelectRoute,
  HubMetaNameSwapSuccessRoute: HubMetaNameSwapSuccessRoute,
  HubMetaNameWarenannahmeAccessRoute: HubMetaNameWarenannahmeAccessRoute,
  HubMetaNameWarenannahmeActionRoute: HubMetaNameWarenannahmeActionRoute,
  HubMetaNameWarenannahmePickupRoute: HubMetaNameWarenannahmePickupRoute,
  HubMetaNameInstantBuyOrderSummaryLazyRoute:
    HubMetaNameInstantBuyOrderSummaryLazyRoute,
  HubMetaNameShopOrderSummaryLazyRoute: HubMetaNameShopOrderSummaryLazyRoute,
  HubMetaNameConsultationIndexRoute: HubMetaNameConsultationIndexRoute,
  HubMetaNameInstantBuyIndexRoute: HubMetaNameInstantBuyIndexRoute,
  HubMetaNameLockB2cIndexRoute: HubMetaNameLockB2cIndexRoute,
  HubMetaNameLockIndexRoute: HubMetaNameLockIndexRoute,
  HubMetaNameRaffleIndexRoute: HubMetaNameRaffleIndexRoute,
  HubMetaNameShopIndexRoute: HubMetaNameShopIndexRoute,
  HubMetaNameSwapIndexRoute: HubMetaNameSwapIndexRoute,
  HubMetaNameWarenannahmeIndexRoute: HubMetaNameWarenannahmeIndexRoute,
  HubMetaNameLockEndRentalReservationIdRoute:
    HubMetaNameLockEndRentalReservationIdRoute,
  HubMetaNameLockEndedReservationIdRoute:
    HubMetaNameLockEndedReservationIdRoute,
  HubMetaNameLockPaySessionIdRoute: HubMetaNameLockPaySessionIdRoute,
  HubMetaNameLockSharedAccessReservationIdRoute:
    HubMetaNameLockSharedAccessReservationIdRoute,
  HubMetaNameLockSummarySpaceIdRoute: HubMetaNameLockSummarySpaceIdRoute,
  HubMetaNameRaffleRaffleIdPlayRoute: HubMetaNameRaffleRaffleIdPlayRoute,
  HubMetaNameRaffleRaffleIdResultRoute: HubMetaNameRaffleRaffleIdResultRoute,
  HubMetaNameRaffleRaffleIdThankYouRoute:
    HubMetaNameRaffleRaffleIdThankYouRoute,
  HubMetaNameSwapEndRentalReservationIdRoute:
    HubMetaNameSwapEndRentalReservationIdRoute,
  HubMetaNameSwapEndedReservationIdRoute:
    HubMetaNameSwapEndedReservationIdRoute,
  HubMetaNameSwapSharedAccessReservationIdRoute:
    HubMetaNameSwapSharedAccessReservationIdRoute,
  HubMetaNameSwapSummarySpaceIdRoute: HubMetaNameSwapSummarySpaceIdRoute,
  HubMetaNameWarenannahmeDeliverSpaceIdRoute:
    HubMetaNameWarenannahmeDeliverSpaceIdRoute,
  HubMetaNameWarenannahmeDeliverIndexRoute:
    HubMetaNameWarenannahmeDeliverIndexRoute,
}

const HubMetaNameRouteRouteWithChildren =
  HubMetaNameRouteRoute._addFileChildren(HubMetaNameRouteRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  HubMetaNameRouteRoute: HubMetaNameRouteRouteWithChildren,
  AuthRoute: AuthRoute,
  LockAccessRoute: LockAccessRoute,
  SubscriptionRoute: SubscriptionRoute,
  ClickncollectCollectRoute: ClickncollectCollectRoute,
  ClickncollectEmailRoute: ClickncollectEmailRoute,
  ClickncollectFinishRoute: ClickncollectFinishRoute,
  ClickncollectOpeningRoute: ClickncollectOpeningRoute,
  OneDeliveryCollectRoute: OneDeliveryCollectRoute,
  OneDeliveryCreditsRoute: OneDeliveryCreditsRoute,
  OneDeliveryFinishRoute: OneDeliveryFinishRoute,
  OneDeliveryNewShipmentRoute: OneDeliveryNewShipmentRoute,
  OneDeliveryOpeningRoute: OneDeliveryOpeningRoute,
  OneDeliveryPickupRoute: OneDeliveryPickupRoute,
  OneDeliverySettingsRoute: OneDeliverySettingsRoute,
  ProfileChangeAppLanguageRoute: ProfileChangeAppLanguageRoute,
  ProfileEditProfileRoute: ProfileEditProfileRoute,
  ProfileImprintRoute: ProfileImprintRoute,
  ProfileLocationsRoute: ProfileLocationsRoute,
  ProfilePaymentRoute: ProfilePaymentRoute,
  ProfilePrivacyPolicyRoute: ProfilePrivacyPolicyRoute,
  ClickncollectIndexRoute: ClickncollectIndexRoute,
  OneDeliveryIndexRoute: OneDeliveryIndexRoute,
  ProfileIndexRoute: ProfileIndexRoute,
  SupportIndexRoute: SupportIndexRoute,
  OneDeliveryBundleBundleIdRoute: OneDeliveryBundleBundleIdRoute,
  OneDeliveryOnboardingComingSoonRoute: OneDeliveryOnboardingComingSoonRoute,
  OneDeliveryOnboardingFinishRoute: OneDeliveryOnboardingFinishRoute,
  OneDeliveryOnboardingPricingRoute: OneDeliveryOnboardingPricingRoute,
  OneDeliveryOnboardingSummaryRoute: OneDeliveryOnboardingSummaryRoute,
  SupportHowToUseClickAndCollectRoute: SupportHowToUseClickAndCollectRoute,
  SupportHowToUseDonationsRoute: SupportHowToUseDonationsRoute,
  SupportHowToUseInstantBuyRoute: SupportHowToUseInstantBuyRoute,
  SupportHowToUseOneDeliveryRoute: SupportHowToUseOneDeliveryRoute,
  SupportHowToUseShopAndCollectRoute: SupportHowToUseShopAndCollectRoute,
  HubHubMetaNameIndexRoute: HubHubMetaNameIndexRoute,
  OneDeliveryOnboardingIndexRoute: OneDeliveryOnboardingIndexRoute,
  SupportHowToUseIndexRoute: SupportHowToUseIndexRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
